<template>
    <div class="vld-parent">
        <div v-if="bool_isAMV">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div class="popupWindow">
                        <CCard>
                            <CCardBody class="modal-body" id="modalDescription">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0">{{this.getLanguage["MEM"][obj_member.I > 0? "EDTM": "ADDM"]}}</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right" @click="close1"><CIcon name=cilX></CIcon></CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <div class="modal-main-content" v-if="!isOUTMOB">
                                    <CRow>
                                        <div :class="this.getUserInfo.AT == 0 ? 'col-md-6' : 'col-md-12'">
                                            <p class="h6" style="margin-top:10px;">
                                                {{this.getLanguage['MEM']['MDTL']}}
                                            </p>
                                        </div>
                                        <div class="col-md-6 d-flex justify-content-end align-items-center" v-if="this.getUserInfo.AT == 0">
                                            <label class="col-form-label-sm mr-2">{{this.getLanguage["MEM"]["ITU"]}} ?</label>
                                            <label class="switch">
                                                <input type="checkbox" :checked="obj_member['ITU']" @change="v => obj_member['ITU'] = v.target.checked" />
                                                <span class="slider round"></span>
                                            </label>
                                        </div>
                                        <div class='subHeaderHR'></div>

                                        <div class="col-md-4">
                                            <label class='col-form-label-sm'>{{this.getLanguage["MEM"]["U"]}}<span class="required" /> :</label>
                                            <CInput type="text" size="sm" :disabled="obj_member.I > 0" vertical :placeholder="this.getLanguage['MEM']['U']" :value="obj_member.U" @change="v => obj_member.U = v" ref="U"></CInput>
                                            <span class="ErrMsg">{{ ValidationMemberErrMsg('U') }}</span>
                                        </div>
                                        <div class="col-md-4" v-if="obj_member.I <= 0 && getUserInfo.AT !== 4">
                                            <label class='col-form-label-sm'>{{this.getLanguage["GL"]["AGT"]}}<span class="required" /> :</label>
                                            <customtreeselect :multiple="false"
                                                              :options="ddAgentList"
                                                              :flat="true"
                                                              :defaultExpandLevel="Infinity"
                                                              :clearable="false"
                                                              :placeholder="this.utilGetDDLanguage('GL.AGT')"
                                                              v-model="obj_member.f_AGI"
                                                              @input="AgentGroupChange"
                                                              value-format="object"
                                                              ref="AGI" />
                                            <span class="ErrMsg">{{ ValidationMemberErrMsg('AGI') }}</span>
                                        </div>
                                        <div class="col-md-4" v-if="obj_member.I > 0 && getUserInfo.AT !== 4">
                                            <CInput type="text" disabled="disabled" size="sm" :label="this.getLanguage['GL']['AGT']" vertical :value="obj_member.AGN" @change="v => obj_member.AGN = v"></CInput>
                                        </div>
                                        <div class="col-md-4">
                                            <label class='col-form-label-sm'>{{this.getLanguage["GL"]["SAGT"]}} :</label>
                                            <treeselect :multiple="false"
                                                        :async="true"
                                                        :key="rtSubBrand"
                                                        :load-options="loadSubBrandOptions"
                                                        :cacheOptions="false"
                                                        :options="ddSubAgentList"
                                                        :defaultOptions="ddDefaultSubBrand"
                                                        :disable-branch-nodes="true"
                                                        :searchPromptText="this.getLanguage['GL']['DDTS']"
                                                        :placeholder="this.utilGetDDLanguage('GL.SAGT')"
                                                        :noResultsText="this.getLanguage['GL']['NRF']"
                                                        v-model="obj_member.f_SAGI"
                                                        @input="SubAgentGroupChange"
                                                        openDirection="below" />
                                        </div>
                                        <div class="col-md-4" v-if="getUserInfo.AT == 4">
                                            <div class="d-flex" style="gap:10px;">
                                                <div>
                                                    <label class='col-form-label-sm' style="width: 100%;">{{this.getLanguage["MEM"]["EAR"]}} :</label>
                                                    <span>
                                                        <label class="switch">
                                                            <input type="checkbox" :checked="obj_member['ARS']" @change="v => obj_member['ARS'] = v.target.checked" />
                                                            <span class="slider round"></span>
                                                        </label>
                                                    </span>
                                                </div>
                                                <div>
                                                    <label class='col-form-label-sm' style="width: 100%;">{{this.getLanguage["MEM"]["EAFF"]}} :</label>
                                                    <span>
                                                        <label class="switch">
                                                            <input type="checkbox" :checked="obj_member['AS']" @change="v => obj_member['AS'] = v.target.checked" />
                                                            <span class="slider round"></span>
                                                        </label>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-md-6">
                                            <label class='col-form-label-sm'>{{this.getLanguage["MEM"]["UP"]}}<span class="required" /> :</label>
                                            <CInput type="password" size="sm" vertical autocomplete="new-password" :placeholder="this.getLanguage['MEM']['UP']" :value="obj_member.UP" @change="v => obj_member.UP = v" ref="UP"></CInput>
                                            <span class="ErrMsg">{{ ValidationMemberErrMsg('UP') }}</span>
                                        </div>
                                        <div class="col-md-6">
                                            <label class='col-form-label-sm'>{{this.getLanguage["MEM"]["CUP"]}}<span class="required" /> :</label>
                                            <CInput type="password" size="sm" vertical autocomplete="confirm-password" :placeholder="this.getLanguage['MEM']['CUP']" :value="obj_member.CUP" @change="v => obj_member.CUP = v" ref="CUP"></CInput>
                                            <span class="ErrMsg">{{ ValidationMemberErrMsg('CUP') }}</span>
                                        </div>

                                        <div class="col-md-6">
                                            <label class='col-form-label-sm'>{{this.getLanguage['MEM']['MTI']}}</label>
                                            <treeselect :multiple="false"
                                                        :load-options="loadEditMemberTypeOptions"
                                                        :noOptionsText="this.getLanguage['GL']['NOA']"
                                                        :options="ddEditMemberTypeList"
                                                        :auto-load-root-options="convertToBool(obj_member.I > 0 && obj_member.MTI)"
                                                        :placeholder="this.utilGetDDLanguage('MEM.MTI')"
                                                        v-model="obj_member.MTI" />
                                        </div>
                                        <div class="col-md-6" v-if="obj_member.I <= 0">
                                            <label class='col-form-label-sm'>{{this.getLanguage['MEM']['CI']}}<span class="required" /> :</label>
                                            <treeselect :multiple="false"
                                                        :load-options="loadEditMemberCurrencyOptions"
                                                        :options="ddEditMemberCurrencyList"
                                                        :auto-load-root-options="false"
                                                        :disable-branch-nodes="true"
                                                        :placeholder="this.utilGetDDLanguage('MEM.CI')"
                                                        v-model="obj_member.CI"
                                                        @input="MemberCurrencyChange"
                                                        ref="CI" />
                                            <span class="ErrMsg">{{ ValidationMemberErrMsg('CI') }}</span>
                                        </div>
                                        <div class="col-md-6" v-if="obj_member.I > 0">
                                            <CInput type="text" disabled="disabled" size="sm" :label="this.getLanguage['MEM']['CI']" vertical :value="obj_member.CIN" @change="v => obj_member.CIN = v"></CInput>
                                        </div>

                                        <div class="col-md-6">
                                            <CInput type="text" size="sm" :label="this.getLanguage['MEM']['DN']" vertical :placeholder="this.getLanguage['MEM']['DN']" :value="obj_member.DN" @change="v => obj_member.DN = v"></CInput>
                                        </div>
                                        <div class="col-md-6">
                                            <label class='col-form-label-sm'>{{this.getLanguage['MEM']['B']}}</label>
                                            <date-range-picker :show-dropdowns="true"
                                                               opens="right"
                                                               :auto-apply="true"
                                                               v-model="editBirthday"
                                                               @update="defaultDateRangePickerUpdateEvent"
                                                               :single-date-picker="true"
                                                               :ranges="false">
                                                <div slot="input" slot-scope="picker">
                                                    <div v-if="editBirthday.startDate != ''">
                                                        <CInput size="sm"
                                                                :value="editBirthday.startDate | moment('DD MMM YYYY')"
                                                                @change="DateTimeChange('DSD',$event)" />
                                                    </div>
                                                    <div v-else>
                                                        <CInput size="sm"
                                                                @change="DateTimeChange('DSD',$event)" />
                                                    </div>
                                                </div>
                                            </date-range-picker>
                                        </div>

                                        <div class="col-md-6" v-if="obj_member.I <= 0">
                                            <label class="col-form-label-sm">{{this.getLanguage["RS"]["RSN"]}} :</label>
                                            <treeselect :multiple="false"
                                                        :load-options="loadEditMemberRegisterSourceOptions"
                                                        :options="ddRegisterSourceList"
                                                        :auto-load-root-options="false"
                                                        :disable-branch-nodes="true"
                                                        :placeholder="this.utilGetDDLanguage('RS.RSN')"
                                                        v-model="obj_member.RRS"
                                                        ref="RRS" />
                                        </div>
                                        <div class="col-md-6" v-if="obj_member.I > 0">
                                            <CInput type="text" disabled="disabled" size="sm" :label="this.getLanguage['MEM']['RSN']" vertical :placeholder="this.getLanguage['MEM']['RSN']" :value="obj_member.RSN" @change="v => obj_member.RSN = v"></CInput>
                                        </div>

                                        <div class="col-md-6">
                                            <div role="group" class="form-group">
                                                <label class='col-form-label-sm'>{{this.getLanguage['MEM']['MKT']}}</label>
                                                <treeselect :multiple="false"
                                                            :cacheOptions="false"
                                                            :load-options="loadMarketerOptions"
                                                            :defaultOptions="ddDefaultMarketerList"
                                                            :options="ddMarketerList"
                                                            :async="true"
                                                            :disable-branch-nodes="true"
                                                            :searchPromptText="this.getLanguage['GL']['DDTS']"
                                                            :placeholder="this.utilGetDDLanguage('MEM.MKT')"
                                                            v-model="obj_member.AI" />
                                            </div>
                                        </div>
                                        <div class="col-md-6" v-if="bool_EnableAffiliate">
                                            <label class='col-form-label-sm'>{{this.getLanguage["BETRPT"]["AFF"]}} :</label>
                                            <treeselect :multiple="false"
                                                        :async="true"
                                                        :key="rtAffiliateKey"
                                                        :cacheOptions="bool_cacheOptionValue"
                                                        :load-options="loadAvailableReferralOptions"
                                                        :defaultOptions="ddDefaultMemberList"
                                                        :options="ddMemberList"
                                                        :disable-branch-nodes="true"
                                                        :disabled="obj_member.DEREF"
                                                        :searchPromptText="this.getLanguage['GL']['DDTS']"
                                                        :placeholder="this.utilGetDDLanguage('BETRPT.AFF')"
                                                        v-model="obj_member.RI" />
                                        </div>
                                        <div class="col-md-6">
                                            <CInput type="text" size="sm" :label="this.getLanguage['MEM']['IC']" vertical :placeholder="this.getLanguage['MEM']['IC']" :value="obj_member.IDC" @change="v => obj_member.IDC = v"></CInput>
                                        </div>

                                        <div class="col-md-12">
                                            <label class="col-form-label-sm">{{this.getLanguage["MEM"]["BR"]}}:</label>
                                            <span class="WCMsg" v-if="this.obj_member.R != null">{{ this.obj_member.R.length }} / 250 </span>
                                            <span class="WCMsg" v-else> 0 / 250 </span>
                                            <textarea maxlength="250" vertical="" rows="5" class="form-control form-control-sm" :value="obj_member.R" @change="TextValueChange('R',$event)" v-shortkey.avoid />
                                        </div>
                                    </CRow>

                                    <br />
                                    <CRow>
                                        <div class="col-md-12">
                                            <p class="h6" style="margin-top:10px;">
                                                {{this.getLanguage['MEM']['CD']}}
                                            </p>
                                        </div>
                                        <div class='subHeaderHR'></div>
                                        <div class="col-md-6">
                                            <CInput v-if="EditContactInfo || obj_member.I == 0" type="email" size="sm" :label="this.getLanguage['MEM']['E']" vertical :placeholder="this.getLanguage['MEM']['E']" :value="obj_member.E" @change="v => obj_member.E = v"></CInput>
                                            <CInput v-else type="email" size="sm" :label="this.getLanguage['MEM']['E']" vertical :placeholder="this.getLanguage['MEM']['E']" :value="HideInfo(HideContactInfo, obj_member.E, 4)" disabled></CInput>
                                        </div>
                                        <div class="col-md-6">
                                            <CInput v-if="EditContactInfo || obj_member.I == 0" type="text" size="sm" :label="this.getLanguage['MEM']['PN']" vertical :placeholder="this.getLanguage['MEM']['PN']" :value="obj_member.PN" @change="v => obj_member.PN = v"></CInput>
                                            <CInput v-else type="text" size="sm" :label="this.getLanguage['MEM']['PN']" vertical :placeholder="this.getLanguage['MEM']['PN']" :value="HideInfo(HideContactInfo, obj_member.PN, 4)" disabled></CInput>
                                        </div>

                                        <div class="col-md-6">
                                            <CInput v-if="EditContactInfo || obj_member.I == 0" type="text" size="sm" :label="this.getLanguage['MEM']['WC']" vertical :placeholder="this.getLanguage['MEM']['WC']" :value="obj_member.WC" @change="v => obj_member.WC = v"></CInput>
                                            <CInput v-else type="text" size="sm" :label="this.getLanguage['MEM']['WC']" vertical :placeholder="this.getLanguage['MEM']['WC']" :value="HideInfo(HideContactInfo, obj_member.WC, 4)" disabled></CInput>
                                        </div>
                                        <div class="col-md-6">
                                            <CInput v-if="EditContactInfo || obj_member.I == 0" type="text" size="sm" :label="this.getLanguage['MEM']['LID']" vertical :placeholder="this.getLanguage['MEM']['LID']" :value="obj_member.LID" @change="v => obj_member.LID = v"></CInput>
                                            <CInput v-else type="text" size="sm" :label="this.getLanguage['MEM']['LID']" vertical :placeholder="this.getLanguage['MEM']['LID']" :value="HideInfo(HideContactInfo, obj_member.LID, 4)" disabled></CInput>
                                        </div>

                                        <div class="col-md-6">
                                            <CInput v-if="EditContactInfo || obj_member.I == 0" type="text" size="sm" :label="this.getLanguage['MEM']['WAID']" vertical :placeholder="this.getLanguage['MEM']['WAID']" :value="obj_member.WAID" @change="v => obj_member.WAID = v"></CInput>
                                            <CInput v-else type="text" size="sm" :label="this.getLanguage['MEM']['WAID']" vertical :placeholder="this.getLanguage['MEM']['WAID']" :value="HideInfo(HideContactInfo, obj_member.WAID, 4)" disabled></CInput>
                                        </div>
                                        <div class="col-md-6">
                                            <CInput v-if="EditContactInfo || obj_member.I == 0" type="text" size="sm" :label="this.getLanguage['MEM']['TGID']" vertical :placeholder="this.getLanguage['MEM']['TGID']" :value="obj_member.TGID" @change="v => obj_member.TGID = v"></CInput>
                                            <CInput v-else type="text" size="sm" :label="this.getLanguage['MEM']['TGID']" vertical :placeholder="this.getLanguage['MEM']['TGID']" :value="HideInfo(HideContactInfo, obj_member.TGID, 4)" disabled></CInput>
                                        </div>

                                        <div class="col-md-6">
                                            <CInput v-if="EditContactInfo || obj_member.I == 0" type="text" size="sm" :label="this.getLanguage['MEM']['ZLID']" vertical :placeholder="this.getLanguage['MEM']['ZLID']" :value="obj_member.ZLID" @change="v => obj_member.ZLID = v"></CInput>
                                            <CInput v-else type="text" size="sm" :label="this.getLanguage['MEM']['ZLID']" vertical :placeholder="this.getLanguage['MEM']['ZLID']" :value="HideInfo(HideContactInfo, obj_member.ZLID, 4)" disabled></CInput>
                                        </div>
                                    </CRow>

                                    <br v-if="obj_member.I > 0" />
                                    <CRow v-if="obj_member.I > 0">
                                        <div class="col-md-12">
                                            <p class="h6" style="margin-top:10px;">
                                                {{this.getLanguage['MEM']['BD']}}
                                            </p>
                                        </div>
                                        <div class='subHeaderHR'></div>
                                        <div class="col-md-6">
                                            <CInput :prepend="obj_member.CS" type="text" disabled="disabled" size="sm" :label="this.getLanguage['MEM']['CBL']" vertical :value="formatNumber(obj_member.CBL, 2, obj_member.CS)" @change="v => obj_member.CBL = RemoveThousandSeparator(v)"></CInput>
                                        </div>
                                        <div class="col-md-6">
                                            <CInput :prepend="obj_member.CS" type="text" disabled="disabled" size="sm" :label="this.getLanguage['MEM']['TO']" vertical :value="formatNumber(obj_member.TTO, 2, obj_member.CS)" @change="v => obj_member.TTO = RemoveThousandSeparator(v)"></CInput>
                                        </div>
                                        <div class="col-md-6">
                                            <CInput :prepend="obj_member.CS" type="text" disabled="disabled" size="sm" :label="this.getLanguage['MEM']['TD']" vertical :value="formatNumber(obj_member.TD, 2, obj_member.CS)" @change="v => obj_member.TD = RemoveThousandSeparator(v)"></CInput>
                                        </div>
                                        <!-- Total Withdraw -->
                                        <div class="col-md-6">
                                            <CInput :prepend="obj_member.CS" type="text" disabled="disabled" size="sm" :label="this.getLanguage['MEM']['TW']" vertical :value="formatNumber(obj_member.TW, 2, obj_member.CS)" @change="v => obj_member.TW = RemoveThousandSeparator(v)"></CInput>
                                        </div>
                                        <!-- Total Bonus -->
                                        <div class="col-md-6">
                                            <CInput :prepend="obj_member.CS" type="text" disabled="disabled" size="sm" :label="this.getLanguage['MEM']['TB']" vertical :value="formatNumber(obj_member.BA  + obj_member.ARA + obj_member.DLSA+ obj_member.AFF + obj_member.PA + obj_member.TNMTA, 2, obj_member.CS)" @change="v => obj_member.BA = RemoveThousandSeparator(v)"></CInput>
                                        </div>
                                    </CRow>


                                    <br v-if="obj_member.I > 0" />
                                    <CRow v-if="obj_member.I > 0">
                                        <div class="col-md-12">
                                            <p class="h6" style="margin-top:10px;">
                                                {{this.getLanguage['MEM']['LRD']}}
                                            </p>
                                        </div>
                                        <div class='subHeaderHR'></div>
                                        <div class="col-md-6">
                                            <CInput type="text" disabled="disabled" size="sm" :label="this.getLanguage['MEM']['CIP']" vertical :value="obj_member.CIP" @change="v => obj_member.CIP = v"></CInput>
                                        </div>
                                        <div class="col-md-6">
                                            <CInput type="text" disabled="disabled" size="sm" :label="this.getLanguage['MEM']['LLTS']" vertical :value="formatDateTime(obj_member.LLTS, 'YYYY-MM-DD HH:mm:ss', 'DD MMM YYYY HH:mm:ss')" @change="v => obj_member.LLTS = v"></CInput>
                                        </div>
                                        <div class="col-md-6">
                                            <CInput type="text" disabled="disabled" size="sm" :label="this.getLanguage['MEM']['LLIP']" vertical :value="obj_member.LLIP" @change="v => obj_member.LLIP = v"></CInput>
                                        </div>
                                        <div class="col-md-6">
                                            <CInput type="text" disabled="disabled" size="sm" :label="this.getLanguage['MEM']['LDTS']" vertical :value="formatDateTime(obj_member.LDTS, 'YYYY-MM-DD HH:mm:ss', 'DD MMM YYYY HH:mm:ss')" @change="v => obj_member.LDTS = v"></CInput>
                                        </div>
                                    </CRow>

                                    <br v-if="EditBankInfo || EditCryptoAccountInfo" />
                                    <CRow v-if="EditBankInfo || EditCryptoAccountInfo">
                                        <div class="col-md-12">
                                            <p class="h6" style="margin-top:10px;">
                                                {{this.getLanguage['MEM']['BAD']}}
                                            </p>
                                        </div>
                                        <!--Bank Account Detail-->
                                        <div class="col-md-12" v-if="EditBankInfo">
                                            <CCard>
                                                <CCardHeader>
                                                    <Strong>{{this.getLanguage['MEM']['BA']}}</Strong>
                                                    <CButton size="sm" color="outline-info" @click="addBank()" v-if="EditBankInfo"><span class='plusIcon cil-plus'></span>{{this.getLanguage["BTN"]["AN"]}}</CButton><span style="display: none;">{{dummyInt}}</span>
                                                </CCardHeader>
                                                <CCardBody>
                                                    <CRow>
                                                        <table class="custom-table custom-table-inPopUp afb-blue" style=" border-bottom: 1px solid #bbb;">
                                                            <thead>
                                                                <tr>
                                                                    <th style="width: 5%;" v-if="EditBankInfo">
                                                                        {{this.getLanguage['GL']['ACT']}}
                                                                    </th>
                                                                    <th style="width: 5%;">
                                                                        {{this.getLanguage["GL"]["NO"]}}
                                                                    </th>
                                                                    <th style="width: 20%;">
                                                                        {{this.getLanguage['MEM']['BI']}}
                                                                    </th>
                                                                    <th style="width: 20%;">
                                                                        {{this.getLanguage['MEM']['BA']}}
                                                                    </th>
                                                                    <th style="width: 20%;">
                                                                        {{this.getLanguage['MEM']['BAN']}}
                                                                    </th>
                                                                    <th style="width: 15%;">
                                                                        {{this.getLanguage['MEM']['DB']}}
                                                                    </th>
                                                                    <th style="width: 15%;">
                                                                        {{this.getLanguage['CAW']['QRC']}}
                                                                    </th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                            <td colspan="100%" v-if=" obj_member.BankList == 0">{{this.getLanguage['GL']['NR']}}</td>
                                                            <tr v-for="(data,index) in obj_member.BankList" :class="data.RS == 1? 'blacklist-row': data.RS == 3? 'freeze-row': data.RS == 4 ? 'warninglist-row' : data.IB? 'highrisk-row':''">
                                                                <td v-if="EditBankInfo">
                                                                    <span id="actionBtnCol">
                                                                        <i class="cil-trash" @click='removeBank(index)'></i> <!--here Remove -->
                                                                        <i class="cil-color-border" style="cursor: pointer" @click='editBank(data,index)'></i> <!--here Edit -->
                                                                    </span>
                                                                </td>
                                                                <td>{{ index+1 }}</td>
                                                                <td>
                                                                    <div class="custom_tooltip" v-if="data.IB && data.RS==2">
                                                                        <span>{{ data.BNM }}</span>
                                                                        <span class="tooltiptext" style="background:red">{{getLanguage['BANK']['SBA']}}</span>
                                                                    </div>
                                                                    <div v-else>
                                                                        {{ data.BNM }}
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <div class="custom_tooltip" v-if="data.IB && data.RS==2">
                                                                        <span>{{ HideInfo(HideBankInfo, data.BA, 4) }}</span>
                                                                        <span class="tooltiptext" style="background:red">{{getLanguage['BANK']['SBA']}}</span>
                                                                    </div>
                                                                    <div v-else>
                                                                        {{ HideInfo(HideBankInfo, data.BA, 4) }}
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <div class="custom_tooltip" v-if="data.IB && data.RS==2">
                                                                        <span>{{ HideInfo(HideBankInfo, data.BAN, 4) }}</span>
                                                                        <span class="tooltiptext" style="background:red">{{getLanguage['BANK']['SBA']}}</span>
                                                                    </div>
                                                                    <div v-else>
                                                                        {{ HideInfo(HideBankInfo, data.BAN, 4) }}
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <div class="text-center">
                                                                        <input type="radio" :checked="data.IDB" :id="'tdbank'+index" @click="DefaultBankChange(data.I)" />
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <a v-if="data.QRCImage || data.QRCURL" href="javascript:void(0)" style="color:blue" @click="setPreview(data.QRCImage, data.QRCURL)">
                                                                        <u>{{getLanguage["GL"]["P"]}}</u>
                                                                    </a>
                                                                </td>
                                                            </tr>
                                                            </tbody>
                                                        </table>
                                                    </CRow>
                                                </CCardBody>
                                            </CCard>
                                        </div>

                                        <!--Crypto Account Detail-->
                                        <div class="col-md-12 mt-3" v-if="EditCryptoAccountInfo">
                                            <CCard>
                                                <CCardHeader>
                                                    <Strong>{{this.getLanguage['MEM']['CRTA']}}</Strong>
                                                    <CButton size="sm" color="outline-info" @click="addCryptoAccount()" v-if="EditCryptoAccountInfo"><span class='plusIcon cil-plus'></span>{{this.getLanguage["BTN"]["AN"]}}</CButton><span style="display: none;">{{dummyInt}}</span>
                                                </CCardHeader>
                                                <CCardBody>
                                                    <CRow>
                                                        <table class="custom-table custom-table-inPopUp afb-blue" style=" border-bottom: 1px solid #bbb;">
                                                            <thead>
                                                                <tr>
                                                                    <th style="width: 5%;" v-if="EditCryptoAccountInfo">
                                                                        {{this.getLanguage['GL']['ACT']}}
                                                                    </th>
                                                                    <th style="width: 5%;">
                                                                        {{this.getLanguage["GL"]["NO"]}}
                                                                    </th>
                                                                    <th style="width: 20%;">
                                                                        {{this.getLanguage['MEM']['CN']}}
                                                                    </th>
                                                                    <th style="width: 20%;">
                                                                        {{this.getLanguage['MEM']['CAN']}}
                                                                    </th>
                                                                    <th style="width: 20%;">
                                                                        {{this.getLanguage['MEM']['CWA']}}
                                                                    </th>
                                                                    <th style="width: 15%;">
                                                                        {{this.getLanguage['MEM']['DCA']}}
                                                                    </th>
                                                                    <th style="width: 15%;">
                                                                        {{this.getLanguage['CAW']['QRC']}}
                                                                    </th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                            <td colspan="100%" v-if=" obj_member.CryptoAccountList == 0">{{this.getLanguage['GL']['NR']}}</td>
                                                            <tr v-for="(data,index) in obj_member.CryptoAccountList" :class="data.RS == 1? 'blacklist-row': data.RS == 3? 'freeze-row': data.RS == 4 ? 'warninglist-row' : data.IB? 'highrisk-row':''">
                                                                <td v-if="EditCryptoAccountInfo">
                                                                    <span id="actionBtnCol">
                                                                        <i class="cil-trash" @click='removeCryptoAccount(index)'></i> <!--here Remove -->
                                                                        <i class="cil-color-border" style="cursor: pointer" @click='editCryptoAccount(data,index)'></i> <!--here Edit -->
                                                                    </span>
                                                                </td>
                                                                <td>{{ index+1 }}</td>
                                                                <td>{{ data.CN }}</td>
                                                                <td>{{ HideInfo(HideCryptoAccountInfo, data.CA, 4) }}</td>
                                                                <td>{{ HideInfo(HideCryptoAccountInfo, data.CAD, 4) }}</td>
                                                                <td>
                                                                    <div class="text-center">
                                                                        <input type="radio" :checked="data.IDA" :id="'tcryptodbank'+index" @click="DefaultCryptoChange(data.I)" />
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <a v-if="data.QRCImage || data.QRCURL" href="javascript:void(0)" style="color:blue" @click="setPreview(data.QRCImage, data.QRCURL)">
                                                                        <u>{{getLanguage["GL"]["P"]}}</u>
                                                                    </a>
                                                                </td>
                                                            </tr>
                                                            </tbody>
                                                        </table>
                                                    </CRow>
                                                </CCardBody>
                                            </CCard>
                                        </div>
                                    </CRow>
                                </div>
                                <div class="modal-main-content" v-if="isOUTMOB">
                                    <CRow>
                                        <div class="col-md-6">
                                            <label class='col-form-label-sm'>{{this.getLanguage["GL"]["SAGT"]}} :</label>
                                            <treeselect :multiple="false"
                                                        :async="true"
                                                        :key="rtSubBrand"
                                                        :load-options="loadSubBrandOptions"
                                                        :cacheOptions="false"
                                                        :options="ddSubAgentList"
                                                        :defaultOptions="ddDefaultSubBrand"
                                                        :disable-branch-nodes="true"
                                                        :searchPromptText="this.getLanguage['GL']['DDTS']"
                                                        :placeholder="this.utilGetDDLanguage('GL.SAGT')"
                                                        v-model="obj_member.f_SAGI"
                                                        @input="SubAgentGroupChange"
                                                        openDirection="below" />
                                            <span class="ErrMsg"></span>
                                        </div>
                                        <div class="col-md-6" v-if="obj_member.I <= 0">
                                            <label class='col-form-label-sm'>{{this.getLanguage['MEM']['CI']}}<span class="required" /> :</label>
                                            <treeselect :multiple="false"
                                                        :load-options="loadEditMemberCurrencyOptions"
                                                        :options="ddEditMemberCurrencyList"
                                                        :auto-load-root-options="false"
                                                        :disable-branch-nodes="true"
                                                        :placeholder="this.utilGetDDLanguage('MEM.CI')"
                                                        v-model="obj_member.CI"
                                                        @input="MemberCurrencyChange"
                                                        ref="CI" />
                                            <span class="ErrMsg">{{ ValidationMemberErrMsg('CI') }}</span>
                                        </div>
                                        <div class="col-md-6" v-if="obj_member.I > 0">
                                            <CInput type="text" disabled="disabled" size="sm" :label="this.getLanguage['MEM']['CI']" vertical :value="obj_member.CIN" @change="v => obj_member.CIN = v"></CInput>
                                        </div>

                                        <div class="col-md-6">
                                            <label class='col-form-label-sm'>{{this.getLanguage["MEM"]["U"]}}<span class="required" /> :</label>
                                            <CInput type="text" size="sm" :disabled="obj_member.I > 0" vertical placeholder='Username' :value="obj_member.U" @change="v => obj_member.U = v" ref="U"></CInput>
                                            <span class="ErrMsg">{{ ValidationMemberErrMsg('U') }}</span>
                                        </div>
                                        <div class="col-md-6">
                                            <label class='col-form-label-sm'>{{this.getLanguage["MEM"]["NUP"]}}<span class="required" /> :</label>
                                            <CInput type="password" size="sm" vertical autocomplete="new-password" :placeholder="this.getLanguage['MEM']['NUP']" :value="obj_member.NUP" @change="TextValueChange('NUP',$event)"></CInput>
                                            <span class="ErrMsg">{{ ValidationMemberErrMsg('NUP') }}</span>
                                        </div>
                                    </CRow>

                                    <CRow v-if="EditBankInfo || EditCryptoAccountInfo">
                                        <div class="col-md-12">
                                            <p class="h6" style="margin-top:10px;">
                                                {{this.getLanguage['MEM']['BAD']}}
                                            </p>
                                        </div>

                                        <!--Bank Account Detail-->
                                        <div class="col-md-12" v-if="EditBankInfo">
                                            <CCard>
                                                <CCardHeader>
                                                    <Strong>{{this.getLanguage['MEM']['BA']}}</Strong>
                                                    <CButton size="sm" color="outline-info" @click="addBank()" v-if="EditBankInfo"><span class='plusIcon cil-plus'></span>{{this.getLanguage["BTN"]["AN"]}}</CButton><span style="display: none;">{{dummyInt}}</span>
                                                </CCardHeader>
                                                <CCardBody>
                                                    <CRow>
                                                        <table class="custom-table custom-table-inPopUp afb-blue" style=" border-bottom: 1px solid #bbb;">
                                                            <thead>
                                                                <tr>
                                                                    <th style="width: 60px;" v-if="EditBankInfo">
                                                                        {{this.getLanguage['GL']['ACT']}}
                                                                    </th>
                                                                    <th style="width: 60px;">
                                                                        {{this.getLanguage["GL"]["NO"]}}

                                                                    </th>
                                                                    <th>
                                                                        {{this.getLanguage['MEM']['BI']}}
                                                                    </th>
                                                                    <th>
                                                                        {{this.getLanguage['MEM']['BA']}}
                                                                    </th>
                                                                    <th>
                                                                        {{this.getLanguage['MEM']['BAN']}}
                                                                    </th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                            <td colspan="100%" v-if=" obj_member.BankList == 0">{{this.getLanguage['GL']['NR']}}</td>
                                                            <tr v-for="(data,index) in obj_member.BankList" :class="data.RS == 1? 'blacklist-row': data.RS == 3? 'freeze-row': data.RS == 4 ? 'warninglist-row' : data.IB? 'highrisk-row':''">
                                                                <td v-if="EditBankInfo">
                                                                    <span id="actionBtnCol">
                                                                        <i class="cil-trash" @click='removeBank(index)'></i> <!--here Remove -->
                                                                        <i class="cil-color-border" style="cursor: pointer" @click='editBank(data,index)'></i> <!--here Edit -->
                                                                    </span>
                                                                </td>
                                                                <td>{{ index+1 }}</td>
                                                                <td>
                                                                    <div class="custom_tooltip" v-if="data.IB && data.RS==2">
                                                                        <span>{{ data.BNM }}</span>
                                                                        <span class="tooltiptext" style="background:red">{{getLanguage['BANK']['SBA']}}</span>
                                                                    </div>
                                                                    <div v-else>
                                                                        {{ data.BNM }}
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <div class="custom_tooltip" v-if="data.IB && data.RS==2">
                                                                        <span>{{ HideInfo(HideBankInfo, data.BA, 4) }}</span>
                                                                        <span class="tooltiptext" style="background:red">{{getLanguage['BANK']['SBA']}}</span>
                                                                    </div>
                                                                    <div v-else>
                                                                        {{ HideInfo(HideBankInfo, data.BA, 4) }}
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <div class="custom_tooltip" v-if="data.IB && data.RS==2">
                                                                        <span>{{ HideInfo(HideBankInfo, data.BAN, 4) }}</span>
                                                                        <span class="tooltiptext" style="background:red">{{getLanguage['BANK']['SBA']}}</span>
                                                                    </div>
                                                                    <div v-else>
                                                                        {{ HideInfo(HideBankInfo, data.BAN, 4) }}
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                            </tbody>
                                                        </table>
                                                    </CRow>
                                                </CCardBody>
                                            </CCard>
                                        </div>

                                        <!--Crypto Account Detail-->
                                        <div class="col-md-12 mt-3" v-if="EditCryptoAccountInfo">
                                            <CCard>
                                                <CCardHeader>
                                                    <Strong>{{this.getLanguage['MEM']['CRTA']}}</Strong>
                                                    <CButton size="sm" color="outline-info" @click="addCryptoAccount()" v-if="EditCryptoAccountInfo"><span class='plusIcon cil-plus'></span>{{this.getLanguage["BTN"]["AN"]}}</CButton><span style="display: none;">{{dummyInt}}</span>
                                                </CCardHeader>
                                                <CCardBody>
                                                    <CRow>
                                                        <table class="custom-table custom-table-inPopUp afb-blue" style=" border-bottom: 1px solid #bbb;">
                                                            <thead>
                                                                <tr>
                                                                    <th style="width: 60px;" v-if="EditCryptoAccountInfo">
                                                                        {{this.getLanguage['GL']['ACT']}}
                                                                    </th>
                                                                    <th style="width: 60px;">
                                                                        {{this.getLanguage["GL"]["NO"]}}
                                                                    </th>
                                                                    <th>
                                                                        {{this.getLanguage['MEM']['CN']}}
                                                                    </th>
                                                                    <th>
                                                                        {{this.getLanguage['MEM']['CAN']}}
                                                                    </th>
                                                                    <th>
                                                                        {{this.getLanguage['MEM']['CWA']}}
                                                                    </th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                            <td colspan="100%" v-if=" obj_member.CryptoAccountList == 0">{{this.getLanguage['GL']['NR']}}</td>
                                                            <tr v-for="(data,index) in obj_member.CryptoAccountList" :class="data.RS == 1? 'blacklist-row': data.RS == 3? 'freeze-row': data.RS == 4 ? 'warninglist-row' : data.IB? 'highrisk-row':''">
                                                                <td v-if="EditCryptoAccountInfo">
                                                                    <span id="actionBtnCol">
                                                                        <i class="cil-trash" @click='removeCryptoAccount(index)'></i> <!--here Remove -->
                                                                        <i class="cil-color-border" style="cursor: pointer" @click='editCryptoAccount(data,index)'></i> <!--here Edit -->
                                                                    </span>
                                                                </td>
                                                                <td>{{ index+1 }}</td>
                                                                <td>{{ data.CN }}</td>
                                                                <td>{{ HideInfo(HideCryptoAccountInfo, data.CA, 4) }}</td>
                                                                <td>{{ HideInfo(HideCryptoAccountInfo, data.CAD, 4) }}</td>
                                                            </tr>
                                                            </tbody>
                                                        </table>
                                                    </CRow>
                                                </CCardBody>
                                            </CCard>
                                        </div>
                                    </CRow>
                                </div>

                                <div style="text-align:center;margin-top:20px">
                                    <CButton color="outline-info" size="sm" @click="saveMember()">
                                        <span class='plusIcon cil-plus'></span>
                                        {{this.getLanguage["BTN"]["SV"]}}
                                    </CButton>
                                </div>
                                <label class="mandatory_Field">{{this.getLanguage['MANDATORY']['FIELDS']}}</label>

                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <div v-if="bool_isMemberBankDetailV">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div class="popupWindow">
                        <CCard style="height:100%; overflow: hidden auto;">
                            <CCardBody class="modal-body" id="modalDescription">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0">{{this.getLanguage["BTN"][obj_bank.I > 0? "ED": "AD"]}} {{this.getLanguage['MEM']['BA']}}</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right"
                                                 @click="closeAddBank()">
                                            <CIcon name=cilX></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <CRow>
                                    <div class="col-md-6">
                                        <label class="col-form-label-sm">{{this.getLanguage['MEM']['BI']}}<span class="required" /> :</label>
                                        <treeselect :multiple="false"
                                                    :options="ddEditBankBrandList"
                                                    :placeholder="this.utilGetDDLanguage('MEM.BI')"
                                                    v-model="obj_bank.BI"
                                                    :cacheOptions="false"
                                                    @input="selectEditBankBrand"
                                                    ref="BI" />
                                        <span class="ErrMsg">{{ ValidationBankErrMsg('BI') }}</span>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="d-flex">
                                            <label class="col-form-label-sm" :for="'dbank'+obj_bank.I">{{this.getLanguage['MEM']['DB']}} :</label>
                                            <input type="checkbox" :checked="obj_bank.IDB" v-model="obj_bank.IDB" class="ml-2" :id="'dbank'+obj_bank.I" @click="DefaultBankChange(obj_bank.I)" />
                                        </div>
                                    </div>
                                </CRow>
                                <CRow>
                                    <div class="col-md-6">
                                        <label class="col-form-label-sm">{{this.getLanguage['MEM']['BA']}}<span class="required" /> :</label>
                                        <CInput type="text" size="sm" vertical :placeholder="this.getLanguage['MEM']['BA']" :value="obj_bank.BA" @change="v => obj_bank.BA = v" ref="BA"></CInput>
                                        <span class="ErrMsg">{{ ValidationBankErrMsg('BA') }}</span>
                                    </div>
                                    <div class="col-md-6">
                                        <label class="col-form-label-sm">{{this.getLanguage['MEM']['BAN']}}<span class="required" /> :</label>
                                        <CInput type="text" size="sm" vertical :placeholder="this.getLanguage['MEM']['BAN']" :value="obj_bank.BAN" @change="v => obj_bank.BAN = v" ref="BAN"></CInput>
                                        <span class="ErrMsg">{{ ValidationBankErrMsg('BAN') }}</span>
                                    </div>
                                </CRow>
                                <CRow>
                                    <CCol col="12">
                                        <label class="col-form-label-sm">{{getLanguage["QRC"]["CI"]}} :</label>
                                        <CTabs variant='tabs' id="imageURLTab">
                                            <CTab :title="getLanguage['CTAB']['UI']" :active="obj_bank.IUT === false ? true: false">
                                                <img v-if="obj_bank.QRCURL || obj_bank.QRCImage"
                                                     width="auto"
                                                     height="150"
                                                     class="mb-2"
                                                     :src="getQRCUrl(obj_bank.QRCImage,obj_bank['QRCURL'])" />
                                                <div class="custom-file">
                                                    <input type="file" class="custom-file-input" id="validatedCustomFile" name="pic" accept="image/*" @change="onQRCSelected" required>
                                                    <label class="custom-file-label" for="validatedCustomFile" v-if="selectedQRCode === null">{{ getLanguage['CTAB']['CAI'] }}</label>
                                                    <label class="custom-file-label" for="validatedCustomFile" v-else>{{selectedQRCode.name}}</label>
                                                    <div class="invalid-feedback">{{ getLanguage['ERR']['8007'] }}</div>
                                                </div>
                                                <label class="col-form-label-sm">
                                                    <p class="my-0">{{getLanguage["RIZ"]["IZ"]}} : 100 x 100</p>
                                                    <p class="my-0">{{getLanguage["ERR"]["MFS100KB"]}}</p>
                                                </label>
                                            </CTab>
                                            <CTab :title="getLanguage['CTAB']['U']" :active="obj_bank.IUT === true ? true: false">
                                                <img v-if="obj_bank.QRCURL || obj_bank.QRCImage"
                                                     width="auto"
                                                     height="150"
                                                     class="mb-2"
                                                     :src="getQRCUrl(obj_bank.QRCImage,obj_bank['QRCURL'])" />
                                                <label class="sr-only" for="inlineFormInputGroupUsername">{{ getLanguage['CTAB']['U'] }}</label>
                                                <div class="input-group">
                                                    <div class="input-group-prepend">
                                                        <div class="input-group-text">{{ getLanguage['CTAB']['U'] }}</div>
                                                    </div>
                                                    <input type="url" class="form-control" :placeholder="getLanguage['CTAB']['U']" v-model="obj_bank.QRCURL">
                                                </div>
                                                <label class="col-form-label-sm">
                                                    <p class="my-0">{{getLanguage["RIZ"]["IZ"]}} : 100 x 100</p>
                                                    <p class="my-0">{{getLanguage["ERR"]["MFS100KB"]}}</p>
                                                </label>
                                            </CTab>
                                        </CTabs>
                                    </CCol>
                                </CRow>
                                <div style="text-align:center;margin-top:20px">
                                    <CButton color="outline-info" size="sm" @click="saveBank()">
                                        <span class='plusIcon cil-plus'></span>
                                        {{this.getLanguage["BTN"]["SV"]}}
                                    </CButton>
                                </div>
                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <div v-if="bool_isMemberCryptoAccountDetailV">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div class="popupWindow">
                        <CCard style="height:100%; overflow: hidden auto;">
                            <CCardBody class="modal-body" id="modalDescription">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0">{{this.getLanguage["BTN"][obj_CryptoAccount.I > 0? "ED": "AD"]}} {{this.getLanguage['MEM']['CRTA']}}</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right"
                                                 @click="closeAddCryptoAccount()">
                                            <CIcon name=cilX></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <CRow>
                                    <div class="col-md-6">
                                        <label class="col-form-label-sm">{{this.getLanguage['MEM']['CN']}}<span class="required" /> :</label>
                                        <treeselect :multiple="false"
                                                    :options="ddEditCryptoNetworkList"
                                                    :placeholder="this.utilGetDDLanguage('MEM.CN')"
                                                    v-model="obj_CryptoAccount.CAI"
                                                    :cacheOptions="false"
                                                    @input="selectEditCryptoNetwork"
                                                    ref="CAI" />
                                        <span class="ErrMsg">{{ ValidationCryptoAccountErrMsg('CAI','CN') }}</span>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="d-flex">
                                            <label class="col-form-label-sm" :for="'dcrypt'+obj_CryptoAccount.I">{{this.getLanguage['MEM']['DCA']}} :</label>
                                            <input type="checkbox" :checked="obj_CryptoAccount.IDA" v-model="obj_CryptoAccount.IDA" class="ml-2" :id="'dcrypt'+obj_CryptoAccount.I" @click="DefaultCryptoChange(obj_CryptoAccount.I)" />
                                        </div>
                                    </div>
                                </CRow>
                                <CRow>
                                    <div class="col-md-6">
                                        <label class="col-form-label-sm">{{this.getLanguage['MEM']['CAN']}}<span class="required" /> :</label>
                                        <CInput type="text" size="sm" vertical :placeholder="this.getLanguage['MEM']['CAN']" :value="obj_CryptoAccount.CA" @change="v => obj_CryptoAccount.CA = v" ref="CA"></CInput>
                                        <span class="ErrMsg">{{ ValidationCryptoAccountErrMsg('CA','CAN') }}</span>
                                    </div>
                                    <div class="col-md-6">
                                        <label class="col-form-label-sm">{{this.getLanguage['MEM']['CWA']}}<span class="required" /> :</label>
                                        <CInput type="text" size="sm" vertical :placeholder="this.getLanguage['MEM']['CWA']" :value="obj_CryptoAccount.CAD" @change="v => obj_CryptoAccount.CAD = v" ref="CAD"></CInput>
                                        <span class="ErrMsg">{{ ValidationCryptoAccountErrMsg('CAD','CWA') }}</span>
                                    </div>
                                </CRow>
                                <CRow>
                                    <CCol col="12">
                                        <label class="col-form-label-sm">{{getLanguage["QRC"]["CI"]}} :</label>
                                        <CTabs variant='tabs' id="imageURLTab">
                                            <CTab :title="getLanguage['CTAB']['UI']" :active="obj_CryptoAccount.IUT === false ? true: false">
                                                <img v-if="obj_CryptoAccount.QRCURL || obj_CryptoAccount.QRCImage"
                                                     width="auto"
                                                     height="150"
                                                     class="mb-2"
                                                     :src="getQRCUrl(obj_CryptoAccount.QRCImage,obj_CryptoAccount['QRCURL'])" />
                                                <div class="custom-file">
                                                    <input type="file" class="custom-file-input" id="validatedCustomFile" name="pic" accept="image/*" @change="onCryptoQRCSelected" required>
                                                    <label class="custom-file-label" for="validatedCustomFile" v-if="selectedQRCode === null">{{ getLanguage['CTAB']['CAI'] }}</label>
                                                    <label class="custom-file-label" for="validatedCustomFile" v-else>{{selectedQRCode.name}}</label>
                                                    <div class="invalid-feedback">{{ getLanguage['ERR']['8007'] }}</div>
                                                </div>
                                                <label class="col-form-label-sm">
                                                    <p class="my-0">{{getLanguage["RIZ"]["IZ"]}} : 100 x 100</p>
                                                    <p class="my-0">{{getLanguage["ERR"]["MFS100KB"]}}</p>
                                                </label>
                                            </CTab>
                                            <CTab :title="getLanguage['CTAB']['U']" :active="obj_CryptoAccount.IUT === true ? true: false">
                                                <img v-if="obj_CryptoAccount.QRCURL || obj_CryptoAccount.QRCImage"
                                                     width="auto"
                                                     height="150"
                                                     class="mb-2"
                                                     :src="getQRCUrl(obj_CryptoAccount.QRCImage,obj_CryptoAccount['QRCURL'])" />
                                                <label class="sr-only" for="inlineFormInputGroupUsername">{{ getLanguage['CTAB']['U'] }}</label>
                                                <div class="input-group">
                                                    <div class="input-group-prepend">
                                                        <div class="input-group-text">{{ getLanguage['CTAB']['U'] }}</div>
                                                    </div>
                                                    <input type="url" class="form-control" :placeholder="getLanguage['CTAB']['U']" v-model="obj_CryptoAccount.QRCURL">
                                                </div>
                                                <label class="col-form-label-sm">
                                                    <p class="my-0">{{getLanguage["RIZ"]["IZ"]}} : 100 x 100</p>
                                                    <p class="my-0">{{getLanguage["ERR"]["MFS100KB"]}}</p>
                                                </label>
                                            </CTab>
                                        </CTabs>
                                    </CCol>
                                </CRow>
                                <div style="text-align:center;margin-top:20px">
                                    <CButton color="outline-info" size="sm" @click="saveCryptoAccount()">
                                        <span class='plusIcon cil-plus'></span>
                                        {{this.getLanguage["BTN"]["SV"]}}
                                    </CButton>
                                </div>
                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <div v-if="bool_isMemberBlacklistDetailV">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div style="height: 220px; width:50%">
                        <CCard style="height:100%; overflow: hidden auto;">
                            <CCardBody class="modal-body" id="modalDescription">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0">{{this.getLanguage['MEM']['ABL']}}</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right"
                                                 @click="close3">
                                            <CIcon name=cilX></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>

                                <div class='subHeaderHR'></div>

                                <CRow>
                                    <CCol col="12">
                                        <label class="col-form-label-sm">{{this.getLanguage["MEM"]["RR"]}}* :</label>
                                        <treeselect :multiple="false"
                                                    :options="dd_rejectreason"
                                                    :placeholder="getLanguage['MEM']['RR']"
                                                    v-model="obj_Reject.reason"
                                                    :limit="1"
                                                    :limitText="count => `+${count}`" />
                                    </CCol>
                                </CRow>
                                <CRow v-if="obj_Reject.reason==999">
                                    <CCol col="12">
                                        <CInput class="margint10" :placeholder="getLanguage['MTA']['RR']" size="sm" :value="obj_Reject.reason2" @change="v => obj_Reject.reason2 = v" :disabled="obj_Reject.reason!=999" maxlength="300"></CInput>
                                    </CCol>
                                </CRow>
                                <CRow>
                                    <CCol col="12">
                                        <span class="ErrMsg">{{ ValidationBlackListErrMsg('reason2') }}</span>
                                    </CCol>
                                </CRow>
                                <div style="text-align:center;margin-top:20px">
                                    <CButton color="outline-info" size="sm" @click="saveBlacklist()">
                                        <span class='plusIcon cil-plus'></span>
                                        {{this.getLanguage["BTN"]["SV"]}}
                                    </CButton>
                                </div>
                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <div v-if="bool_isMemberFreezeDetailV">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div style="height: 220px; width:50%">
                        <CCard style="height:100%; overflow: hidden auto;">
                            <CCardBody class="modal-body" id="modalDescription">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0">{{this.getLanguage['MEM']['AF']}}</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right"
                                                 @click="close4">
                                            <CIcon name=cilX></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>

                                <div class='subHeaderHR'></div>

                                <CRow>
                                    <CCol col="12">
                                        <label class="col-form-label-sm">{{this.getLanguage["MEM"]["FRR"]}}* :</label>
                                        <treeselect :multiple="false"
                                                    :options="dd_rejectreasonF"
                                                    :placeholder="getLanguage['MEM']['FRR']"
                                                    v-model="obj_RejectF.reason"
                                                    :limit="1"
                                                    :limitText="count => `+${count}`" />
                                    </CCol>
                                </CRow>
                                <CRow v-if="obj_RejectF.reason==999">
                                    <CCol col="12">
                                        <CInput class="margint10" :placeholder="getLanguage['MTA']['FRR']" size="sm" :value="obj_RejectF.reason2" @change="v => obj_RejectF.reason2 = v" :disabled="obj_RejectF.reason!=999" maxlength="300"></CInput>
                                    </CCol>
                                </CRow>
                                <CRow>
                                    <CCol col="12">
                                        <span class="ErrMsg">{{ ValidationFreezeErrMsg('reason2') }}</span>
                                    </CCol>
                                </CRow>
                                <div style="text-align:center;margin-top:20px">
                                    <CButton color="outline-info" size="sm" @click="saveFreeze()">
                                        <span class='plusIcon cil-plus'></span>
                                        {{this.getLanguage["BTN"]["SV"]}}
                                    </CButton>
                                </div>
                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <div v-if="bool_isMemberGameSetting">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div class="popupWindow">
                        <CCard style="height:100%; overflow: hidden auto;">
                            <CCardBody class="modal-body" id="modalDescription">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0">{{this.getLanguage["MEM"]["MGS"]}}</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right"
                                                 @click="closeEditMemberGameSetting()">
                                            <CIcon name=cilX></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class="modal-main-content" id="MGS">
                                    <CRow>
                                        <template v-if="!noData" v-for="(data,index) in arr_memberGameSetting">
                                            <!--TOTAL NET WINNING-->
                                            <template v-if="data.SN == 'TNW'">
                                                <CCol col="12" v-if="data.CN">
                                                    <h6 class="card-title section-title2">
                                                        <span></span> {{renderCategory(data.GCI)}}
                                                        <div class="custom_tooltip" style="padding-left:5px;">
                                                            <i class="fa fa-question-circle"></i>
                                                            <div class="tooltiptext2">{{getLanguage["HELP"]["TNW"]}}</div>
                                                        </div>
                                                    </h6>
                                                </CCol>
                                                <CCol col="6" class="mb-2">
                                                    <CInput class="gsetting-field col-sm-7 input-group-sm px-0"
                                                            size="sm" horizontal
                                                            :placeholder="arr_memberGameSetting[index].FSV === '' ? '' : `${getLanguage['GS'][arr_memberGameSetting[index].SettingHierarchy]}(${ThousandSeparator(arr_memberGameSetting[index].FSV, CheckIsThousandCurrency(data.ISOC,this) ? 3 : 2)})`"
                                                            :label="data.ISOC"
                                                            :value="(arr_memberGameSetting[index].SV === '' || arr_memberGameSetting[index].SV === null) ? '' : ThousandSeparator(arr_memberGameSetting[index].SV, CheckIsThousandCurrency(data.ISOC,this) ? 3 : 2)"
                                                            @change="event => { arr_memberGameSetting[index].SV = RemoveThousandSeparator(event, CheckIsThousandCurrency(data.ISOC,this) ? 3 : 2) }"
                                                            min="0.0" step="0.1" />
                                                </CCol>
                                            </template>
                                            <!--Category Items Title + Max Win Multiplier -->
                                            <template v-else-if="data.SN == 'MWM'">
                                                <CCol col="12" @click="DisplayGCI(data.GCI)" v-if="data.CN">
                                                    <h6 class="card-title section-title2"><span></span>{{renderCategory(data.GCI)}} <i :class="arr_displayGCI.includes(data.GCI) ? 'chevron-container chevron-up' : 'chevron-container chevron-down'"></i> </h6>
                                                </CCol>

                                                <template v-if="arr_displayGCI.includes(data.GCI) && data.GPI == 0 && ( data.SVT==0 || data.SVT==2 )">
                                                    <div class="col-sm-6 form-group form-row">
                                                        <label class="col-form-label col-sm-6 col-form-label-sm">{{RenderSettingName(data.SN, data.GPI)}}</label>
                                                        <input class="form-control form-control-sm col-sm-6"
                                                               :placeholder="arr_memberGameSetting[index].FSV === '' ? '' : `${getLanguage['GS'][arr_memberGameSetting[index].SettingHierarchy]}(${ThousandSeparator(arr_memberGameSetting[index].FSV, 0)})`"
                                                               required
                                                               :value="(arr_memberGameSetting[index].SV === '' || arr_memberGameSetting[index].SV === null) ? '' : ThousandSeparator(arr_memberGameSetting[index].SV, 0)"
                                                               @change="event => { arr_memberGameSetting[index].SV = RemoveThousandSeparator(event.target.value, 0)}"
                                                               min="0.0" step="0.1" />
                                                    </div>
                                                    <div class="custom_tooltip" style="padding-left:5px;">
                                                        <i class="fa fa-question-circle"></i>
                                                        <span class="tooltiptext2"  style="width: 450px;">{{getLanguage["HELP"]["SMWA"]}}</span>
                                                    </div>
                                                </template>
                                            </template>

                                            <template v-else-if="(data.SN == 'OF')">
                                                <template v-if="arr_displayGCI.includes(data.GCI)">
                                                    <div class="gsetting-lblprovider col-sm-12 mb-2" v-if="!data.ISOC">
                                                        <span @click="DisplayGPI(data.GPI)" class="pointer" v-if="data.GPI === 4">{{ renderProviderName('AFB1188') }}</span>
                                                        <span @click="DisplayGPI(data.GPI)" class="pointer" v-else-if="data.GPI === 139">{{ renderProviderName(data.PN) }}</span>
                                                        <span @click="DisplayGPI(data.GPI)" class="pointer" v-else>{{ renderProviderName(data.PN) }}</span>

                                                        <template v-if="data.GPI===23">
                                                            <div class="custom_tooltip" style="padding-left:5px;">
                                                                <i class="fa fa-question-circle"></i>
                                                                <span class="tooltiptext2">{{getLanguage["GL"]["CQ9S"]}}</span>
                                                            </div>
                                                        </template>
                                                    </div>

                                                    <template v-if="arr_displayGPI.includes(data.GPI) && data.GPI != 0 && (data.SVT==1)">
                                                        <!--OnOff-->
                                                        <div class="col-sm-6 form-group form-row pb-2">
                                                            <label class="col-form-label col-sm-6 col-form-label-sm">{{RenderSettingName(data.SN, data.GPI)}}</label>
                                                            <div class="col-sm-6 input-group-sm">
                                                                <treeselect :multiple="false"
                                                                            :options="onOffOptionList"
                                                                            :placeholder="arr_memberGameSetting[index].FSV === '' ? '' : `${getLanguage['GS'][arr_memberGameSetting[index].SettingHierarchy]}(${arr_memberGameSetting[index].FSV === '1' ?  getLanguage['GS']['ON'] :  getLanguage['GS']['OFF']})`"
                                                                            required
                                                                            v-model="arr_memberGameSetting[index].SV" />
                                                            </div>
                                                        </div>
                                                        <!--AFB1188 SportList-->
                                                        <!--<template v-for="(setting, idx) in arr_memberGameSetting" v-if="setting.SN === 'AfbSports' && data.GPI === 4 && selectedSports[setting.GPI]">
                                                            <div class="col-sm-6 form-group form-row pb-2">
                                                                <label class="col-form-label col-sm-6 col-form-label-sm">{{RenderSettingName('SportList', setting.GPI)}}<span class="required" /></label>
                                                                <div class="col-sm-6 input-group-sm">
                                                                    <treeselect :multiple="true"
                                                                                :options="afbSports"
                                                                                :placeholder="setting.FSV === '' ? '' :  `${getLanguage['GS'][setting.SettingHierarchy]}(${setting.FSV.split(',').length})`"
                                                                                required
                                                                                :limit="1"
                                                                                :limitText="count => `+${count}`"
                                                                                v-model="selectedSports[setting.GPI].selections" />
                                                                </div>
                                                            </div>
                                                        </template>-->

                                                        <div class="col-sm-12 mb-4">
                                                            <!--AFB1188 & GGCS-->
                                                            <div class="nav nav-tabs" id="nav-tab" role="tablist" style="font-size:12px;border-bottom:0px">
                                                                <template v-for="item in dd_gp_currency['AFB1188']" v-if="data.GPI === 4">
                                                                    <button :class="(selectedGP == data.GPI && selectedISOC == item)? 'p-2 nav-link active' : 'p-2 nav-link'" @click="selectedGP = data.GPI;selectedISOC = item">{{ item }}</button>
                                                                </template>
                                                                <template v-for="item in dd_gp_currency[data.PN]" v-if="data.GPI === 139">
                                                                    <button :class="(selectedGP == data.GPI && selectedISOC == item)? 'p-2 nav-link active' : 'p-2 nav-link'" @click="selectedGP = data.GPI;selectedISOC = item">{{ item }}</button>
                                                                </template>
                                                                <template v-for="item in dd_gp_currency[data.PN]" v-if="data.GPI !== 4 && data.GPI !== 139">
                                                                    <button :class="(selectedGP == data.GPI && selectedISOC == item)? 'p-2 nav-link active' : 'p-2 nav-link'" @click="selectedGP = data.GPI;selectedISOC = item">{{ item }}</button>
                                                                </template>
                                                            </div>

                                                            <!--Bet Limit-->
                                                            <div class="card tab-content p-2" v-if="selectedGP == data.GPI">
                                                                <div class="row">
                                                                    <template v-for="(data2,index2) in arr_memberGameSetting" v-if="(selectedGP == data2.GPI && selectedISOC == data2.ISOC)  && arr_displayGCI.includes(data2.GCI) && arr_displayGPI.includes(data2.GPI)">
                                                                        <template>
                                                                            <template v-if="data2.GPI != 0 && ( data2.SVT==0 || data2.SVT==2 )">
                                                                                <div class="col-sm-6 form-group form-row">
                                                                                    <label class="col-form-label col-sm-7 col-form-label-sm">{{RenderSettingName(data2.SN, data2.GPI)}}</label>
                                                                                    <input class="form-control form-control-sm col-sm-5"
                                                                                           :placeholder="arr_memberGameSetting[index2].FSV === '' ? '' : `${getLanguage['GS'][arr_memberGameSetting[index2].SettingHierarchy]}(${ThousandSeparator(arr_memberGameSetting[index2].FSV, (data2.GPI === 4 || data2.GPI === 139) ? 0 : (CheckIsThousandCurrency(data2.ISOC,this) ? 3 : 2))})`"
                                                                                           required
                                                                                           :value="(arr_memberGameSetting[index2].SV === '' || arr_memberGameSetting[index2].SV === null) ? '' : ThousandSeparator(arr_memberGameSetting[index2].SV, (data2.GPI === 4 || data2.GPI === 139) ? 0 : (CheckIsThousandCurrency(data2.ISOC,this) ? 3 : 2))"
                                                                                           @change="event => { arr_memberGameSetting[index2].SV = RemoveThousandSeparator(event.target.value, (data2.GPI === 4 || data2.GPI === 139) ? 0 : (CheckIsThousandCurrency(data2.ISOC,this) ? 3 : 2)) }"
                                                                                           min="0.0" step="0.1" />
                                                                                    <span class="col-sm-6 offset-sm-6 ErrMsg">{{ValidationErrMsg(data2.GPI,index2)}}</span>
                                                                                </div>
                                                                            </template>
                                                                        </template>
                                                                    </template>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </template>
                                                </template>
                                            </template>
                                        </template>
                                    </CRow>
                                </div>
                                <div style="text-align:center;margin-top:20px">
                                    <CButton color="outline-info" size="sm" @click="saveMemberGameSetting()">
                                        <span class='plusIcon cil-plus'></span>
                                        {{this.getLanguage["BTN"]["SV"]}}
                                    </CButton>
                                </div>
                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>
    </div>
</template>


<script>
    import { constAccessType, constRejectReasonBL, constRejectReasonF, constTranType, consDeviceType, consTypeofmember } from '@/modules/Constant.js'
    import DateRangePicker from 'vue2-daterange-picker'
    import Treeselect from '@riophae/vue-treeselect'
    import { customtreeselect } from '@/views/CustomControl/index.js'
    import moment from "moment";
    import genericHelper from "@/modules/GenericHelper.js";
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import { mapGetters, mapActions } from 'vuex';
    import { required, email, sameAs, requiredIf, alphaNum, decimal, minValue, numeric } from 'vuelidate/lib/validators'
    import Vue from 'vue'
    import Sortable from 'sortablejs';
    import draggable from 'vuedraggable';
    import $ from 'jquery'

    //Vue.use(require('vue-shortkey'))

    export default {
        props: ['editMemberInfo', 'editMemberBlock', 'editMemberFreeze', 'editMemberGame'],
        mixins: [genericHelper],
        components: {
            DateRangePicker,
            Treeselect,
            customtreeselect,
            Sortable,
            draggable
        },
        data() {
            return {
                bool_fingerPrintLoading: [],
                bool_Advanced: false,
                bool_showSearchBar: true,
                bool_isMobileDevice: false,
                bool_isAMV: false,
                bool_isMemberBlacklistDetailV: false,
                bool_isMemberFreezeDetailV: false,
                bool_isMemberGameSetting: false,

                //sensBtn: true,
                str_tableSortBy: "I", //(sort the table col name)
                bool_isSort: true, // Table Ascending Descending
                // dropdown value
                ddAgentList: null,
                ddSubAgentList: null,
                ddDefaultSubBrand: [],
                ddMemberRankList: null,
                ddEditMemberRankList: null,
                ddEditMemberTypeList: null,
                ddEditMemberCurrencyList: null,
                ddSearchMemberCurrencyList: null,
                ddSearchMemberRank: [],
                //ddSearchMemberRank:[{id:"0",label:"No Rank"},{id:"1",label:"Rank 1"},{id:"2",label:"Rank 2"},{id:"3",label:"Rank 3"},{id:"4",label:"Rank 4"},{id:"5",label:"Rank 5"}],
                ddEditMemberReferralList: null,
                ddMemberStatusList: null,
                ddBankBrandList: null,
                ddEditBankBrandList: null,
                ddDepositedList: null,
                ddToDepositList: null,
                ddCreditBalanceList: null,
                ddMemberList: [],
                ddMarketerListFS: [],
                ddMarketerList: [],
                ddDefaultMarketerList: null,
                ddTypeName: null,
                // search fields
                searchAgi: null,
                searchSAgi: null,
                searchCurrency: null,
                searchAgent: null,
                searchSubAgent: null,
                searchMemberRank: null,
                searchUsername: null,
                searchMarketer: null,
                searchDisplayName: null,
                searchRegisterSourceName: null,
                searchDomainName: null,
                searchIP: null,
                searchBirthday: { startDate: null, endDate: null },
                searchMemberStatus: 2,
                searchReferralUN: null,
                searchReferralCode: null,
                searchRegisterDtRange: { startDate: "", endDate: "" },
                searchLDepositDtRange: { startDate: "", endDate: "" },
                searchLPromoDtRange: { startDate: "", endDate: "" },
                searchPhone: null,
                searchEmail: null,
                searchWeChat: null,
                searchLine: null,
                searchBank: null,
                searchBankAccName: null,
                searchBankAcc: null,
                searchTWG: 1,
                searchPKVU: null,
                searchDeposited: null,
                searchToDeposit: null,
                searchCreditBalance: null,
                searchCIP: null,
                searchDevice: null,
                searchTypeofmember: null,
                searchTypeName: null,
                arr_MemberList: [],
                obj_member: {},
                bool_isMemberListAdvancedSearchModalVisible: false,
                editBirthday: { startDate: null, endDate: null },
                obj_bank: {
                    BI: null,
                    BA: null,
                    BAN: null,
                    QRCImage: "",
                    QRCURL: "",
                    IUT: false,
                    status: "existing",
                },
                bool_isMemberBankDetailV: false,
                bool_bankCV: false,
                bool_memberCV: false,
                bool_haveRef: false,
                bool_isTopup: false,
                IsMember: 0,
                dummyInt: 0,
                bool_blacklistCV: false,
                bool_freezeCV: false,
                obj_blacklist: {},
                obj_freeze: {},
                constAccessType: constAccessType,
                dd_rejectreason: [],
                dd_rejectreasonF: [],
                obj_Reject: {
                    "reason": null,
                    "reason2": ""
                },
                obj_RejectF: {
                    "reason": null,
                    "reason2": ""
                },
                editBankIndex: -1,
                arr_memberGameSetting: [],
                noData: true,
                regexInt: new RegExp("^[0-9]+$"),
                regexDecimal: new RegExp("^[0-9]+[\.]?[0-9]*$"),
                opened: [],
                arry_visitorMembers: {},
                arry_systemId: {},
                ML_A: false,
                ML_E: false,
                ML_D: false,
                MBA_A: false,
                MAR_E: false,
                HideContactInfo: false,
                EditContactInfo: false,
                HideBankInfo: false,
                EditBankInfo: false,
                searchExactRegIP: true,
                searchExactLastLogInIP: true,
                bool_isBAR: false,
                bool_isReward: false,
                isSubAgent: false,
                arr_FV: {
                    "AGI": null,
                },
                obj_ad:
                {
                    AGI: null,
                    SAGAGI: null,
                    MI: null,
                    R: "",
                    RS: 2,
                    IMA: 1,
                    TT: null,
                    AC: 1,
                    TA: "",
                    BB: "",
                    CI: null
                },
                dd_tranType: [],
                dd_deviceType: [],
                dd_typeofmember: [],
                CurrencySymbol: "",
                requestBrand: "",
                requestUsername: "",
                bool_cacheOptionValue: true,
                bool_cacheMarketerOptionValue: true,
                requestDA: [],
                requestWA: [],
                requestDLS: [],

                //SubAgent / Outlet
                bool_isDepositV: false,
                obj_OutletTran: [],
                obj_OutletTran2: [],
                obj_ManualPromo: {
                    "AGI": 0,
                    "CNT": "",
                    "CNM": "",
                    "R": [],
                },
                bool_EnableAffiliate: false,
                ddDefaultMemberList: [],
                rtAffiliateKey: 0,
                rtSubBrand: 0,
                dd_promotion: [],
                rtPromoKey: 0,
                strTnxConfirm: "",
                bool_isWithdraw: false,
                //////////
                bool_EBAIN: false,
                str_invalidNumericMsg: "",
                //Member Game Setting
                arr_displayGCI: [],
                arr_displayGPI: [],
                arr_currencies: [],
                dd_gp_currency: [],
                selectedSports: {},
                selectedGP: 0,
                selectedISOC: 0,
                afbSports: [{
                    id: 0,
                    label: 'ALL',
                    children: [
                        { "id": 1, "label": "Soccer" },
                        { "id": 2, "label": "Basketball" },
                        { "id": 3, "label": "Tennis" },
                        { "id": 4, "label": "Financials" },
                        { "id": 5, "label": "4DSpecials" },
                        { "id": 7, "label": "Olympic" },
                        { "id": 8, "label": "USFootball" },
                        { "id": 9, "label": "Baseball" },
                        { "id": 10, "label": "IceHockey" },
                        { "id": 11, "label": "Snooker" },
                        { "id": 12, "label": "Rugby" },
                        { "id": 13, "label": "Darts" },
                        { "id": 14, "label": "Boxing" },
                        { "id": 15, "label": "Formula1" },
                        { "id": 16, "label": "MotorSports" },
                        { "id": 17, "label": "Golf" },
                        { "id": 18, "label": "Pool" },
                        { "id": 19, "label": "Futsal" },
                        { "id": 20, "label": "Badminton" },
                        { "id": 21, "label": "WaterPolo" },
                        { "id": 22, "label": "TableTennis" },
                        { "id": 23, "label": "Cricket" },
                        { "id": 24, "label": "Volleyball" },
                        { "id": 25, "label": "Handball" },
                        { "id": 26, "label": "Cycling" },
                        { "id": 27, "label": "BeachSoccer" },
                        { "id": 29, "label": "Athletics" },
                        { "id": 30, "label": "WinterSport" },
                        { "id": 31, "label": "Squash" },
                        { "id": 33, "label": "HuayThai" },
                        { "id": 34, "label": "ESports" },
                        { "id": 35, "label": "MuayThai" },
                        { "id": 36, "label": "EUROPE VIEW" }
                    ]
                }],

                ddRegisterSourceList: null,
                selectedFile: null,
                selectedQRCode: null,
                searchExcludeSubAgent: false,

                str_afterSaveOutlet_URL: "",
                bool_OutletAfterSave: false,
                bool_checkCopy: false,
                hasTransLoading: false,

                obj_CryptoAccount: {
                    CAI: null,
                    CN: null,
                    CA: null,
                    CAD: null,
                    QRCImage: "",
                    QRCURL: "",
                    IUT: false,
                    status: "existing",
                },
                bool_isMemberCryptoAccountDetailV: false,
                bool_CryptoAccountCV: false,
                editCryptoAccountIndex: -1,
                ddEditCryptoNetworkList: null,
                HideCryptoAccountInfo: false,
                EditCryptoAccountInfo: false,
                dd_RewardList: [],
                obj_Reward:
                {
                    MI: null,
                    PRI: null
                },
            }
        },
        methods: {
            ...mapActions('UserInfo', ['setSearchCriteriaAGI']),
            ...mapActions('CurrencyInfo', ['setThousandCurrency']),

            resizeTableHead() {
                this.initTableObserver();
                // Set up scroll synchronization
                const header = this.$el.querySelector("#tHead");
                const body = this.$el.querySelector("#tBody");

                header.addEventListener("scroll", () => {
                    body.scrollLeft = header.scrollLeft;
                });

                body.addEventListener("scroll", () => {
                    header.scrollLeft = body.scrollLeft;
                });
            },
            calculateWidths() {
                $('#tHead, #tBody').scrollLeft(0);
                const tables = this.$el.querySelectorAll('#tBody .custom-table');
                const headerCells = this.$el.querySelectorAll('#tHead .custom-table thead tr:nth-child(1) th');

                if (!headerCells.length) return;

                tables.forEach((table) => {
                    const bodyCells = table.querySelectorAll('tbody tr:first-child td');
                    if (!bodyCells.length) return;

                    // Reset all widths
                    [...headerCells, ...table.querySelectorAll('tbody tr td')].forEach(cell => cell.style.width = '');

                    bodyCells.forEach((cell, index) => {
                        if (!headerCells[index]) return;  // Add a safety check to avoid undefined errors

                        const headerWidth = headerCells[index].getBoundingClientRect().width;
                        const bodyWidth = cell.getBoundingClientRect().width;
                        const width = `${Math.max(bodyWidth, headerWidth)}px`;

                        headerCells[index].style.width = width;
                        table.querySelectorAll(`tbody tr td:nth-child(${index + 1}):not(td table td)`).forEach(td => td.style.width = width);
                    });
                });
            },
            initTableObserver() {
                const bodyTable = this.$el.querySelector('#tBody');

                // Observe changes in the body table
                const observer = new MutationObserver(() => {
                    this.calculateWidths(); // Recalculate widths when rows change
                });

                observer.observe(bodyTable, { childList: true, subtree: true });
                this.calculateWidths();
            },
            DateTimeChange(type, event) {
                if (type == "RSD") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.searchRegisterDtRange.startDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["SD"]), 1000);
                    } else {
                        this.searchRegisterDtRange.startDate = "";
                    }
                }
                if (type == "RED") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.searchRegisterDtRange.endDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["ED"]), 1000);
                    } else {
                        this.searchRegisterDtRange.endDate = "";
                    }
                }
                if (type == "DSD") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.searchLDepositDtRange.startDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["SD"]), 1000);
                    } else {
                        this.searchLDepositDtRange.startDate = "";
                    }
                }
                if (type == "DED") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.searchLDepositDtRange.endDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["ED"]), 1000);
                    } else {
                        this.searchLDepositDtRange.endDate = "";
                    }
                }
                if (type == "BD") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.searchBirthday.startDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["SD"]), 1000);
                    } else {
                        this.searchBirthday.startDate = "";
                    }
                }
            },
            TextValueChange(type, event) {
                if (type == "R") {
                    this.obj_member.R = event.target.value;
                }
                else if (type == "RJ") {
                    this.obj_ad.R = event.target.value;
                }
                else if (type == "NUP") {
                    this.obj_member.NUP = event;
                    this.obj_member.UP = event;
                    this.obj_member.CUP = event;
                }
            },
            close1() {
                this.bool_isAMV = !this.bool_isAMV;
                this.bool_cacheOptionValue = false;
                this.ddMemberList = [];
                this.bool_memberCV = false;

                //this.editMemberInfo = null;

                this.$parent.editMemberInfo = null;
            },

            getCurrencyList() {
                var that = this;
                var agi = 0;

                if (this.searchAgent) {
                    var agentList = this.searchAgent.split("-");
                    agi = agentList[1];
                }

                this.getDataApi(`/api/dd/currency/${agi}`,
                    function (d, s) {
                        if (s) {
                            that.ddSearchMemberCurrencyList = d.dropdownlist;
                        }
                    });
            },
            getAgentGroup() {
                var that = this;
                this.getDataApi(`/api/dd/ag/1/0`,
                    function (d, s) {
                        if (s) {
                            that.ddAgentList = that.deepClone(d.dropdownlist);

                            if (that.ddAgentList.length > 0) {
                                that.ddAgentList.forEach(that.disableAgentGroupParent);
                            }
                        }
                    });
            },
            disableAgentGroupParent(item, index) {
                var agi = item.id.split("-");
                //if (agi[0] != "3") {
                //    item.isDisabled = true;
                //}

                if (parseInt(agi[0]) < 3) {
                    item.isDisabled = true;
                }

                if (item.children && item.children.length > 0) {
                    item.children.forEach(this.disableAgentGroupParent);
                }
            },

            //member
            setMember() {
                if (this.obj_member.AGI == 0) {
                    this.obj_member.AGI = null;
                }
                else {
                    this.obj_member.f_AGI = {
                        id: "3-" + this.obj_member.AGI
                    };
                    this.GetBankBrandDropDown(this.obj_member.AGI, this.obj_member.CI);
                    this.GetCryptoNetworkDropDown(this.obj_member.AGI, this.obj_member.CI);
                }

                if (this.obj_member.SAGI != null && this.obj_member.SAGI != 0) {
                    //this.loadDefaultSubBrand(this.obj_member.SAGI);
                    this.obj_member.f_SAGI = this.obj_member.SAGI;
                } else {
                    this.obj_member.f_SAGI = null;
                }

                this.obj_member.f_RI = null;

                if (this.obj_member.TB == null) {
                    this.obj_member.TB = 0;
                }

                if (this.obj_member.MRI == 0) {
                    this.obj_member.MRI = null;
                }

                if (this.obj_member.CI == 0) {
                    this.obj_member.CI = null;
                } else {
                    if (this.obj_member.SAGI > 0) {
                        this.searchAgi = this.obj_member.SAGI;
                    } else {
                        this.searchAgi = this.obj_member.AGI;
                    }
                    // check the affiliate setting had been activated or not
                    if (this.obj_member.CI > 0 && this.obj_member.I > 0) {
                        var that = this;
                        that.GetBankBrandDropDown(that.obj_member.AGI, that.obj_member.CI);
                        that.GetCryptoNetworkDropDown(that.obj_member.AGI, that.obj_member.CI);
                        that.ddDefaultMemberList = [];
                        that.getDataApi(`/api/m/checkaff/${that.obj_member.AGI}/${that.obj_member.CI}`,
                            function (d, s) {
                                if (s) {
                                    that.bool_EnableAffiliate = d;
                                }
                            });
                    }

                    this.obj_member.CIN = this.getLanguage['CUR'][this.obj_member.IC];
                }



                if (this.obj_member.MTI == 0) {
                    this.obj_member.MTI = null;
                }
                if (this.obj_member.AI > 0) {
                    this.ddDefaultMarketerList = [{ id: this.obj_member.AI, label: this.obj_member.AN }];

                } else {
                    this.ddDefaultMarketerList = null;
                    this.obj_member.AI = null;
                }

                if (this.obj_member.ITU == 1) {
                    this.obj_member.ITU = true;
                }
                else {
                    this.obj_member.ITU = false;
                }

                if (this.getUserInfo.AT == 4) {
                    if (this.obj_member.ARS == 2) {
                        this.obj_member.ARS = true;
                    }
                    else {
                        this.obj_member.ARS = false;
                    }

                    if (this.obj_member.AS == 2) {
                        this.obj_member.AS = true;
                    }
                    else {
                        this.obj_member.AS = false;
                    }
                }

                this.bool_EnableAffiliate = true;
                if (this.obj_member.RI == 0) {
                    this.obj_member.RI = null;
                    this.bool_haveRef = false;
                    this.ddDefaultMemberList = [];
                } else {
                    this.bool_haveRef = true;
                    this.bool_cacheOptionValue = true;
                    if (this.obj_member.SAGI > 0) {
                        this.loadDefaultMember(this.obj_member.SAGI, this.obj_member.I, this.obj_member.RI);
                    } else {
                        this.loadDefaultMember(this.obj_member.AGI, this.obj_member.I, this.obj_member.RI);
                    }

                }

                this.editBirthday = { startDate: this.obj_member.B, endDate: null };

            },
            editMember(d) {
                this.$parent.bool_fullLoading = true;
                this.bool_memberCV = false;
                this.bool_EnableAffiliate = false;
                this.editBirthday = { startDate: null, endDate: null };
                this.ddEditMemberTypeList = null;
                if (d == 0) {
                    this.obj_member = {
                        I: 0,
                        RS: 2,
                        AGI: null,
                        f_AGI: null,
                        f_SAGI: null,
                        f_RI: null,
                        U: null,
                        UP: null,
                        CUP: null,
                        NUP: null,
                        MRI: null,
                        CI: null,
                        DN: "",
                        B: null,
                        E: null,
                        PN: null,
                        WC: null,
                        LID: null,
                        RC: null,
                        RI: null,
                        CBL: null,
                        TD: null,
                        TTO: null,
                        TB: null,
                        RTO: null,
                        HEB: false,
                        IsMember: 0,
                        ITU: false,
                        ICI: 0,
                        AI: null,
                        AN: null,
                        DEREF: false,
                        HEC: false,
                        IDC: ""
                    };


                    this.bool_isAMV = !this.bool_isAMV;

                    this.ddDefaultMemberList = [];
                    this.ddDefaultMarketerList = null;
                    if (this.ddAgentList && this.ddAgentList.length > 0 && this.ddAgentList[0].children == undefined) {
                        var at = 0;
                        at = this.ddAgentList[0].id.split("-")[0];
                        if ((at == 3 || at == 4) && this.ddAgentList.length < 2) {
                            this.obj_member.f_AGI = this.ddAgentList[0];

                            this.AgentGroupChange();
                        }
                    }

                    if (this.getUserInfo.AT === 4) {
                        if (d == 0) {
                            this.obj_member.f_SAGI = this.searchSubAgent;
                            this.rtSubBrand = this.rtSubBrand == 0 ? 1 : 0;
                            this.SubAgentGroupChange();
                        }
                        else {
                            this.loadDefaultSubBrand(0, true);
                        }
                    }
                    else {
                        this.ddDefaultSubBrand = [];
                    }

                    this.$parent.bool_fullLoading = false;
                }
                else {
                    var that = this;
                    this.loadDefaultSubBrand(d.AGI);
                    this.getDataApi(`/api/m/g/${d.AGI}/${d.I}`,
                        function (d, s) {
                            if (s) {
                                that.obj_member = d.D;
                                that.obj_member.HEB = false;
                                that.obj_member.HEC = false;
                                that.setMember();
                                that.bool_isAMV = !that.bool_isAMV;
                            }
                            that.$parent.bool_fullLoading = false;
                        });
                }
            },
            saveMember() {
                var has_qrcode_img = false;
                this.obj_member.IsMember = 0;
                this.obj_member.ICI = 0;

                this.bool_memberCV = true;
                this.$v.obj_member.$touch();
                if (!this.$v.obj_member.$error) {
                    if (this.editBirthday) {
                        if (this.editBirthday.startDate) {
                            //this.obj_member.B = this.editBirthday.startDate;
                            this.obj_member.B = moment(this.editBirthday.startDate, "DD MMM YYYY").add(1, 'days');
                        }
                    }

                    if (this.obj_member.BankList) {
                        for (var i = this.obj_member.BankList.length - 1; i >= 0; i--) {
                            if (this.obj_member.BankList[i].I <= 0) {
                                this.obj_member.BankList[i].I = 0;
                            }
                            if (this.obj_member.BankList[i].QRCImage) {
                                has_qrcode_img = true;
                            }
                        }
                    }

                    if (this.obj_member.CryptoAccountList) {
                        for (var i = this.obj_member.CryptoAccountList.length - 1; i >= 0; i--) {
                            if (this.obj_member.CryptoAccountList[i].I <= 0) {
                                this.obj_member.CryptoAccountList[i].I = 0;
                            }
                            if (this.obj_member.CryptoAccountList[i].QRCImage) {
                                has_qrcode_img = true;
                            }
                        }
                    }

                    if (this.obj_member.DN == null || this.obj_member.DN == "") {
                        this.obj_member.DN = this.obj_member.U;
                    }

                    if (this.obj_member.f_SAGI != null && this.obj_member.f_SAGI != "") {
                        this.obj_member.SAGI = this.obj_member.f_SAGI;
                    }

                    if (this.obj_member.ITU) {
                        this.obj_member.ITU = 1;
                    }
                    else {
                        this.obj_member.ITU = 0;
                    }

                    if (this.getUserInfo.AT == 4) {
                        if (this.obj_member.AS) {
                            this.obj_member.AS = 2;
                        }
                        else {
                            this.obj_member.AS = 1;
                        }

                        if (this.obj_member.ARS) {
                            this.obj_member.ARS = 2;
                        }
                        else {
                            this.obj_member.ARS = 1;
                        }
                    }

                    var that = this;
                    this.$parent.bool_fullLoading = true;
                    this.$parent.bool_fullScreen = true;


                    if (has_qrcode_img) {
                        this.postDataApiWithAttach(`/api/m/s`, this.obj_member,
                            function (d, s) {
                                that.$parent.bool_fullLoading = false;
                                that.$parent.bool_fullScreen = false;
                                if (s) {
                                    if (d.ERR && d.ERR.length > 0 && d.ERR[0].ERRC == 99) {
                                        that.$fire({
                                            title: that.getLanguage["MEM"]["CA"],
                                            html: that.getLanguage["MEM"]["CICI"],
                                            width: '30em',
                                            showCancelButton: true,
                                            confirmButtonText: 'Ok',
                                            cancelButtonText: 'Cancel',
                                            reverseButtons: true,
                                            customClass: {
                                                title: 'afb-alert-title',
                                                content: 'afb-alert-content',
                                                actions: 'afb-alert-action'
                                            }
                                        }).then((result) => {
                                            if (result.value == true) {

                                                that.$parent.bool_fullLoading = true;
                                                that.obj_member['ICI'] = 1;
                                                that.postDataApiWithAttach(`/api/m/s`, that.obj_member,
                                                    function (d, s) {
                                                        that.$parent.bool_fullLoading = false;

                                                        ///
                                                        that.$parent.bool_fullLoading = false;
                                                        ////
                                                        if (s) {
                                                            that.bool_isAMV = false;
                                                            if (that.$parent.bool_isMobileDevice) {
                                                                that.$parent.bool_OutletAfterSave = true;
                                                            }

                                                            that.$parent.editMemberInfo = null;
                                                            if (that.$route.path == '/M/ML') {
                                                                that.$parent.getMemberList();
                                                            } else if (that.$route.path == '/M/ML/CheckingMember') {
                                                                that.$parent.getData();
                                                            }
                                                        }
                                                    });
                                            }
                                        });
                                    }
                                    else {
                                        that.bool_isAMV = false;
                                        if (that.$parent.bool_isMobileDevice) {
                                            that.$parent.bool_OutletAfterSave = true;
                                        }

                                        that.$parent.editMemberInfo = null;
                                        if (that.$route.path == '/M/ML') {
                                            that.$parent.getMemberList();
                                        } else if (that.$route.path == '/M/ML/CheckingMember') {
                                            that.$parent.getData();
                                        }
                                    }
                                }
                            });
                    }
                    else {
                        this.postDataApi(`/api/m/s`, this.obj_member,
                            function (d, s) {
                                that.$parent.bool_fullLoading = false;
                                if (s) {
                                    if (d.ERR && d.ERR.length > 0 && d.ERR[0].ERRC == 99) {
                                        that.$fire({
                                            title: that.getLanguage["MEM"]["CA"],
                                            html: that.getLanguage["MEM"]["CICI"],
                                            width: '30em',
                                            showCancelButton: true,
                                            confirmButtonText: 'Ok',
                                            cancelButtonText: 'Cancel',
                                            reverseButtons: true,
                                            customClass: {
                                                title: 'afb-alert-title',
                                                content: 'afb-alert-content',
                                                actions: 'afb-alert-action'
                                            }
                                        }).then((result) => {
                                            if (result.value == true) {

                                                that.$parent.bool_fullLoading = true;
                                                that.obj_member['ICI'] = 1;
                                                that.postDataApi(`/api/m/s`, that.obj_member,
                                                    function (d, s) {
                                                        that.$parent.bool_fullLoading = false;
                                                        if (s) {
                                                            that.bool_isAMV = false;
                                                            if (that.bool_isMobileDevice) {
                                                                that.bool_OutletAfterSave = true;
                                                            }

                                                            that.$parent.editMemberInfo = null;
                                                            if (that.$route.path == '/M/ML') {
                                                                that.$parent.getMemberList();
                                                            } else if (that.$route.path == '/M/ML/CheckingMember') {
                                                                that.$parent.getData();
                                                            }
                                                        }
                                                    });
                                            }
                                        });
                                    }
                                    else {
                                        that.bool_isAMV = false;
                                        if (that.bool_isMobileDevice) {
                                            that.bool_OutletAfterSave = true;
                                        }

                                        that.$parent.editMemberInfo = null;
                                        if (that.$route.path == '/M/ML') {
                                            that.$parent.getMemberList();
                                        } else if (that.$route.path == '/M/ML/CheckingMember') {
                                            that.$parent.getData();
                                        }
                                    }
                                }
                            });
                    }
                } else {
                    //find out the unfilled and required inputm then focus it.
                    const validation = this.$v["obj_member"];
                    if (!validation) {
                        return;
                    }

                    const input = this.findRequiredInput(validation, this.$refs);
                    if (!input || typeof input.focus !== "function") {
                        return;
                    }

                    input.focus();
                }
            },
            ValidationMemberErrMsg(value) {
                if (this.bool_memberCV) {
                    if (this.$v.obj_member[value].required != undefined && !this.$v.obj_member[value].required) {
                        return String.format(this.utilGetErrorLanguage('1001'), this.utilGetErrorLanguage(value == 'AGI' ? 'GL.AGT' : ('MEM.' + value)));
                    } else if (this.$v.obj_member[value].sameAsPassword != undefined && !this.$v.obj_member[value].sameAsPassword) {
                        return this.getLanguage['MEM']['ERUP'];
                    } else if (this.$v.obj_member[value].email != undefined && !this.$v.obj_member[value].email) {
                        return this.getLanguage['MEM']['ERE'];
                    } else if (this.$v.obj_member[value].alphaNum != undefined && !this.$v.obj_member[value].alphaNum) {
                        return this.getLanguage['MEM']['ERAN'];
                    }
                }
            },
            AgentGroupChange(value) {
                this.ddEditMemberRankList = null;
                this.obj_member.MRI = null;
                this.ddEditMemberTypeList = null;
                this.obj_member.MTI = null;
                this.ddEditMemberCurrencyList = null;
                this.ddRegisterSourceList = null;
                this.obj_member.CI = null;
                this.ddEditBankBrandList = null;
                this.ddEditCryptoNetworkList = null;
                this.obj_member.SAGI = 0;
                this.obj_member.f_SAGI = null;
                if (this.obj_member.f_AGI) {
                    this.obj_member.f_SAGI = null;
                    var agiSelectedValue = '';
                    if (typeof this.obj_member.f_AGI === 'string') {
                        agiSelectedValue = this.obj_member.f_AGI;
                        var agentList = agiSelectedValue.split("-");
                        this.obj_member.AGI = agentList[agentList.length - 1];
                    }
                    else {
                        agiSelectedValue = this.obj_member.f_AGI.id;
                        var agentList = agiSelectedValue.split("-");
                        if (agentList[0] == "4") {
                            this.obj_member.AGI = this.obj_member.f_AGI.extra;
                            this.obj_member.SAGI = agentList[agentList.length - 1];
                        }
                        else {
                            this.obj_member.AGI = agentList[agentList.length - 1];
                        }
                    }
                }
                this.obj_member.BankList = null;
                this.obj_member.CryptoAccountList = null;

                var that = this;
                this.getDataApi(`/api/m/isebain/${this.obj_member.AGI}`,
                    function (d, s) {
                        if (s) {
                            if (d) {
                                that.bool_EBAIN = true;
                            }
                            else {
                                that.bool_EBAIN = false;
                            }
                        }
                    });
                //that.sensBtn = ((that.isSENS == 1 && that.obj_member.AGI != that.curAGI) ? true : false);

                if (this.getUserInfo.AT !== 4) {
                    const options = {
                        callback: () => {
                            if (that.ddEditMemberCurrencyList.length == 1) {
                                that.obj_member.CI = that.ddEditMemberCurrencyList[0].id;
                            }
                        }
                    };
                    this.loadEditMemberCurrencyOptions(options);
                }
            },
            SubAgentGroupChange(value) {
                var that = this;
                if (this.obj_member.I == 0) {
                    this.ddEditMemberRankList = null;
                    this.obj_member.MRI = null;
                    this.ddEditMemberTypeList = null;
                    this.obj_member.MTI = null;
                    this.ddEditMemberCurrencyList = null;
                    this.ddRegisterSourceList = null;
                    this.obj_member.CI = null;
                    this.ddEditBankBrandList = null;
                    this.ddEditCryptoNetworkList = null;
                }

                this.obj_member.SAGI = 0;

                if (this.obj_member.f_SAGI) {
                    if (this.obj_member.I > 0 && !this.bool_haveRef) {
                        this.obj_member.RI = null;
                    }

                    var agiSelectedValue = '';
                    if (typeof this.obj_member.f_SAGI === 'string') {
                        agiSelectedValue = this.obj_member.f_SAGI;
                        var agentList = agiSelectedValue.split("-");
                        this.obj_member.SAGAGI = agentList[agentList.length - 1];
                    }
                    else {
                        agiSelectedValue = this.obj_member.f_SAGI.id;
                        var agentList = agiSelectedValue.split("-");
                        if (agentList[0] == "4") {
                            this.obj_member.SAGAGI = this.obj_member.f_SAGI.extra;
                            this.obj_member.SAGI = agentList[agentList.length - 1];
                        }
                        else {
                            this.obj_member.SAGAGI = agentList[agentList.length - 1];
                        }
                    }
                    this.searchAgi = this.obj_member.SAGAGI;
                } else if (!this.obj_member.f_SAGI && this.obj_member.I > 0 && !this.bool_haveRef) {
                    this.searchAgi = this.obj_member.AGI;
                    this.obj_member.RI = null;
                }
                if (this.obj_member.I == 0) {
                    if (this.bool_isMobileDevice) {
                        this.getRandomUser_Pass()
                    }
                }

                if (value) {
                    this.getDataApi(`/api/sag/g/${value}`,
                        function (d, s) {
                            if (s) {
                                //that.bool_EnableAffiliate = d.D.IOL == 1;

                                //Get subagent's agent
                                if (that.getUserInfo.AT === 4)
                                    that.obj_member.AGI = d.D.PGI;
                            }
                        });
                }

                const options = {
                    callback: () => {
                        if (that.ddEditMemberCurrencyList != null && that.ddEditMemberCurrencyList.length == 1) {
                            that.obj_member.CI = that.ddEditMemberCurrencyList[0].id;
                        }
                    }
                };
                this.loadEditMemberCurrencyOptions(options);

                if (this.obj_member.I == 0) {
                    this.obj_member.BankList = null;
                    this.obj_member.CryptoAccountList = null;
                }
                this.GetBankBrandDropDown(this.obj_member.SAGAGI, this.obj_member.CI);
                this.GetCryptoNetworkDropDown(this.obj_member.SAGAGI, this.obj_member.CI);
            },
            loadEditMemberCurrencyOptions({ action, callback, instanceId }) {
                var that = this;
                this.ddEditMemberCurrencyList = null;

                if (!this.obj_member.AGI) {
                    callback(this.getLanguage['MEM']['PSAA']);
                }
                else {
                    if (this.obj_member.f_SAGI > 0) {
                        this.getDataApi(`/api/dd/cur/${this.obj_member.f_SAGI}`,
                            function (d, s) {
                                if (s && d && d.dropdownlist) {
                                    that.ddEditMemberCurrencyList = d.dropdownlist;
                                }
                                else {
                                    that.ddEditMemberCurrencyList = null;
                                }

                                callback();
                            });
                    }
                    else {
                        this.getDataApi(`/api/dd/cur/${this.obj_member.AGI}`,
                            function (d, s) {
                                if (s && d && d.dropdownlist) {
                                    that.ddEditMemberCurrencyList = d.dropdownlist;
                                }
                                else {
                                    that.ddEditMemberCurrencyList = null;
                                }

                                callback();
                            });
                    }
                }
            },
            loadDefaultMember(agi, mi = 0, ri = 0) {
                var that = this;

                this.getDataApi(`/api/dd/creferral/_/${agi}/${mi}/${ri}`,
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            that.ddDefaultMemberList = d.dropdownlist;
                            that.rtAffiliateKey = that.rtAffiliateKey == 0 ? 1 : 0;
                        }
                        else {
                            that.ddDefaultMemberList = [];
                        }
                    });
            },
            loadDefaultSubBrand(agi, isFirstLoad = false) {
                var that = this;
                var searchQuery = "0";

                this.getDataApi(`/api/dd/subbrand/0/${searchQuery}/${agi}`,
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            that.ddDefaultSubBrand = that.deepClone(d.dropdownlist);
                            if (isFirstLoad) {
                                that.searchSubAgent = that.ddDefaultSubBrand[0].id;
                                that.rtSubBrand = that.rtSubBrand == 0 ? 1 : 0;

                                if (that.$route.path == '/M/ML') {
                                    that.$parent.getMemberList();
                                } else if (that.$route.path == '/M/ML/CheckingMember') {
                                    that.$parent.getData();
                                }
                            }
                        }
                    });
            },
            loadSubBrandOptions({ action, searchQuery, callback }) {
                var that = this;
                var parentAGI = 0;

                if (this.obj_member && this.obj_member.f_AGI && this.bool_isAMV) {
                    var agentList = this.obj_member.f_AGI.id.split("-");
                    parentAGI = agentList[agentList.length - 1];
                }
                else if (this.searchAgent && !this.bool_isAMV) {
                    var agentList = this.searchAgent.split("-");
                    parentAGI = agentList[agentList.length - 1];
                }
                else if (this.getUserInfo.AT === 4) {
                    parentAGI = 0;
                }
                else {
                    this.ddSubAgentList = [];
                    callback(this.getLanguage['MEM']['PSAA']);
                }

                if (searchQuery == null || searchQuery == '' || searchQuery.trim() == '' || searchQuery.trim().length < 3) {
                    that.ddSubAgentList = [];
                    callback(this.getLanguage['MEM']['PS3']);
                }
                else {
                    searchQuery = encodeURIComponent(searchQuery);
                    this.getDataApi(`/api/dd/subbrand/0/${searchQuery}/${parentAGI}`,
                        function (d, s) {
                            if (s && d && d.dropdownlist) {
                                that.ddSubAgentList = d.dropdownlist;
                                //that.bool_cacheOptionValue = true;
                                if (that.getUserInfo.AT === 4)
                                    that.SubAgentGroupChange(parentAGI);
                            }
                            else {
                                that.ddSubAgentList = [];
                            }
                            callback(null, that.ddSubAgentList);
                        });
                }
            },
            getRandomUser_Pass() {
                var username = "";
                var pass = "";
                var that = this;
                this.getDataApi(`/api/m/rand/${that.obj_member.SAGAGI}`,
                    function (d, s) {
                        if (s) {
                            that.obj_member.U = d.D.r_user_name;
                            that.obj_member.UP = d.D.r_password;
                            that.obj_member.CUP = d.D.r_password;
                            that.obj_member.NUP = d.D.r_password;
                            that.str_afterSaveOutlet_URL = d.D.membersite_url;
                            that.$forceUpdate();


                        }
                    });
            },
            GetBankBrandDropDown(agi, ci) {
                var that = this;
                ci = ci ? ci : 0;

                this.ddEditBankBrandList = null;
                this.getDataApi(`/api/dd/memwithbank/${agi}/${ci}`,
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            that.ddEditBankBrandList = d.dropdownlist;
                        }
                        else {
                            that.ddEditBankBrandList = null;
                        }
                    });
            },
            GetCryptoNetworkDropDown(agi, ci) {
                var that = this;
                ci = ci ? ci : 0;

                this.ddEditCryptoNetworkList = null;
                this.getDataApi(`/api/dd/cryptonetwork/${agi}/${ci}`,
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            that.ddEditCryptoNetworkList = d.dropdownlist;
                        }
                        else {
                            that.ddEditCryptoNetworkList = null;
                        }
                    });
            },
            loadEditMemberRegisterSourceOptions({ action, callback, instanceId }) {
                var that = this;

                if (!this.obj_member.AGI) {
                    callback(this.getLanguage['MEM']['PSAA']);
                }
                else {
                    this.getDataApi(`/api/dd/mrsource/${this.obj_member.AGI}`,
                        function (d, s) {
                            if (s && d && d.dropdownlist) {
                                that.ddRegisterSourceList = d.dropdownlist;
                            }
                            else {
                                that.ddRegisterSourceList = null;
                            }

                            callback();
                        });
                }
            },
            loadMarketerOptions({ action, searchQuery, callback }) {
                var that = this;
                if (!this.obj_member.AGI) {
                    callback(this.getLanguage['MEM']['PSAA']);
                }
                else if (searchQuery == null || searchQuery == '' || searchQuery.trim() == '' || searchQuery.trim().length < 3) {
                    that.ddMarketerList = [];
                    callback(this.getLanguage['MEM']['PS3']);
                }
                else {
                    searchQuery = encodeURIComponent(searchQuery);
                    this.getDataApi(`/api/dd/marketer/0/${searchQuery}/${this.obj_member.AGI}`,
                        function (d, s) {
                            if (s && d && d.dropdownlist) {
                                that.ddMarketerList = d.dropdownlist;
                            }
                            else {
                                that.ddMarketerList = [];
                            }

                            callback(null, that.ddMarketerList);
                        });
                }
            },
            loadAvailableReferralOptions({ action, searchQuery, callback }) {
                var that = this;
                if (searchQuery == null || searchQuery == '' || searchQuery.trim() == '' || searchQuery.trim().length < 3) {
                    that.ddMemberList = [];
                    callback(this.getLanguage['MEM']['PS3']);
                }
                else {
                    searchQuery = encodeURIComponent(searchQuery);
                    this.getDataApi(`/api/dd/areferral/${searchQuery}/${this.searchAgi}/${this.obj_member.I}/${this.obj_member.CI}`,
                        function (d, s) {
                            if (s && d && d.dropdownlist) {
                                that.ddMemberList = d.dropdownlist;
                                //that.bool_cacheOptionValue = true;
                            }
                            else {
                                that.ddMemberList = [];
                            }

                            callback(null, that.ddMemberList);
                        });
                }
            },
            loadEditMemberTypeOptions({ action, callback, instanceId }) {
                var that = this;
                if (!this.obj_member.AGI) {
                    callback(this.getLanguage['MEM']['PSAA']);
                }
                else {
                    this.getDataApi(`/api/dd/mType/${this.obj_member.AGI}`,
                        function (d, s) {
                            if (s && d && d.dropdownlist) {
                                that.ddEditMemberTypeList = d.dropdownlist;
                            }
                            else {
                                that.ddEditMemberTypeList = null;
                            }

                            callback();
                        });
                }
            },
            MemberCurrencyChange(value) {
                var agi = this.obj_member.AGI;
                var ci = this.obj_member.CI;
                var mi = this.obj_member.I;
                var that = this;
                if (ci > 0 && mi == 0) {
                    this.GetBankBrandDropDown(agi, ci);
                    this.GetCryptoNetworkDropDown(agi, ci);
                    this.ddDefaultMemberList = [];
                    if (agi > 0) {
                        if (this.obj_member.f_SAGI > 0) {
                            this.searchAgi = this.obj_member.f_SAGI;
                            this.obj_member.RI = null;
                        } else {
                            this.searchAgi = agi;
                            this.obj_member.RI = null;
                        }
                        this.getDataApi(`/api/m/checkaff/${agi}/${ci}`,
                            function (d, s) {
                                if (s) {
                                    that.bool_EnableAffiliate = d;
                                }
                            });
                    }
                } else {
                    that.bool_EnableAffiliate = false;
                }
            },

            //bank
            addBank() {
                this.obj_bank = {
                    BI: null,
                    BA: null,
                    BAN: null,
                    QRCImage: "",
                    QRCURL: "",
                    IUT: false,
                    status: "new",
                }
                if (!this.obj_member.AGI || !this.obj_member.CI) {
                    this.showErrorMessage(null, this.getLanguage['BB']['PSAGC'], 1000);
                }
                else {
                    this.bool_isMemberBankDetailV = true;
                }
                this.editBankIndex = -1;
                this.str_invalidNumericMsg = "";
            },
            editBank(data, index) {
                this.bool_bankCV = false;
                this.obj_bank = Object.assign({}, data);
                this.bool_isMemberBankDetailV = true;
                this.editBankIndex = index;
                this.str_invalidNumericMsg = "";
                this.obj_bank.IUT = false;
                if (this.obj_bank.status != "new") {
                    this.obj_bank.status = "edit";
                }
            },
            removeBank(index) {
                this.dummyInt = 0;

                //remove directly inside the list
                this.$delete(this.obj_member.BankList, index);

                this.dummyInt++;
            },
            saveBank() {
                this.bool_bankCV = true;
                var iurlTab = this.getIURLTabIndex();
                if (iurlTab != 1) { // external img url
                    if (this.obj_bank.QRCURL != null && this.obj_bank.QRCURL != "") {
                        //if img url is not empty
                        this.obj_bank.IUT = true;
                        this.obj_bank.QRCImage = "";
                    }
                }
                this.$v.obj_bank.$touch();

                let isValid = true;

                if (this.bool_EBAIN) {
                    if (isNaN(this.obj_bank.BAN)) {
                        this.str_invalidNumericMsg = String.format(this.getLanguage['ERR']['1009'], this.getLanguage['BAL']['BANO']);
                        isValid = false;
                        return;
                    }
                }

                if (!this.$v.obj_bank.$error && isValid) {
                    var exist = false;
                    if (!this.obj_member.BankList) {
                        this.obj_member.BankList = [];
                    }
                    for (var i = this.obj_member.BankList.length - 1; i >= 0; i--) {
                        if ((this.obj_member.BankList[i].BNM == this.obj_bank.BNM && this.obj_member.BankList[i].BA == this.obj_bank.BA && this.obj_member.BankList[i].BAN == this.obj_bank.BAN)
                            && this.editBankIndex != i) {
                            exist = true;
                            break;
                        }
                        // remove duplicate default bank account
                        if (this.obj_bank.IDB) {
                            this.obj_member.BankList[i].IDB = false;
                        }
                    }
                    if (!exist && this.editBankIndex != -1) {
                        this.obj_member.HEB = true;

                        this.obj_member.BankList[this.editBankIndex] = this.obj_bank;
                        this.bool_isMemberBankDetailV = false;
                        this.bool_bankCV = false;
                        this.editBankIndex = -1;
                        this.obj_bank = {};
                    }
                    else if (exist) {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1002'), this.getLanguage["MEM"]["BA"]), 1000);
                    }
                    else {
                        //this.obj_member.HEB = true;
                        this.obj_member.BankList.push(this.obj_bank);
                        this.bool_isMemberBankDetailV = false;
                        this.bool_bankCV = false;
                        this.editBankIndex = -1;
                        this.obj_bank = {};
                    }
                } else {
                    //find out the unfilled and required inputm then focus it.
                    const validation = this.$v["obj_bank"];
                    if (!validation) {
                        return;
                    }

                    const input = this.findRequiredInput(validation, this.$refs);
                    if (!input || typeof input.focus !== "function") {
                        return;
                    }

                    input.focus();
                }
                this.selectedQRCode = null;
            },
            closeAddBank() {
                this.obj_bank = {
                    BI: null,
                    BA: null,
                    BAN: null,
                    QRCImage: "",
                    QRCURL: "",
                    IUT: false,
                    status: "new",
                }
                this.bool_isMemberBankDetailV = !this.bool_isMemberBankDetailV

                this.editBankIndex = -1;
                this.selectedQRCode = null;
            },
            ValidationBankErrMsg(value) {

                if (this.bool_bankCV) {
                    if (!this.$v.obj_bank[value].required) {
                        return String.format(this.utilGetErrorLanguage('1001'), this.utilGetErrorLanguage('MEM.' + value));
                    }
                    //else if (this.$v.obj_bank[value].alphaNum != undefined && !this.$v.obj_bank[value].alphaNum) {
                    //    return String.format(this.getLanguage['ERR']['1008'], this.getLanguage['BAL']['BANO']);
                    //}
                }

                if (this.bool_EBAIN) {
                    if (this.str_invalidNumericMsg != "" && value == "BAN") {
                        return this.str_invalidNumericMsg;
                    }
                }

            },
            DefaultBankChange(bankId) {
                if (this.obj_member && this.obj_member.BankList.length > 0) {
                    for (var i = 0; i < this.obj_member.BankList.length; i++) {
                        if (this.obj_member.BankList[i].I == bankId && this.obj_member.BankList[i].IDB) {
                            this.obj_member.BankList[i].IDB = false;
                            this.obj_bank.IDB = false;
                        } else if (this.obj_member.BankList[i].I == bankId && !this.obj_member.BankList[i].IDB) {
                            this.obj_member.BankList[i].IDB = true;
                            this.obj_bank.IDB = true;
                        } else {
                            this.obj_member.BankList[i].IDB = false;
                            this.obj_bank.IDB = false;
                        }
                    }
                    this.obj_member.HEB = true;
                }
            },
            onQRCSelected(event) {
                //this.obj_bank['BL'] = null
                var image = this.validateFile(event, 0.1, [".jpg", ".jpeg", ".png"]);
                //this.selectedQRCode = this.validateFile(event, 0.1, [".jpg", ".jpeg", ".png"]);
                if (image) {
                    //document.getElementById('preview_img').src = URL.createObjectURL(image);
                    this.obj_bank.QRCImage = image;
                    this.selectedQRCode = image;
                }
            },
            selectEditBankBrand({ value, instanceId }) {
                this.obj_bank.BNM = '';
                if (this.obj_bank.BI) {
                    for (var i = 0; i < this.ddEditBankBrandList.length; i++) {
                        if (this.ddEditBankBrandList[i].id == this.obj_bank.BI) {
                            this.obj_bank.BNM = this.ddEditBankBrandList[i].label;
                            break;
                        }
                    }
                }
            },
            //Cryto Account
            addCryptoAccount() {
                this.obj_CryptoAccount = {
                    CAI: null,
                    CN: null,
                    CA: null,
                    CAD: null,
                    QRCImage: "",
                    QRCURL: "",
                    IUT: false,
                    status: "new",
                }
                if (!this.obj_member.AGI || !this.obj_member.CI) {
                    this.showErrorMessage(null, this.getLanguage['BB']['PSAGC'], 1000);
                }
                else {
                    this.bool_isMemberCryptoAccountDetailV = true;
                }
                this.editCryptoAccountIndex = -1;
                this.str_invalidNumericMsg = "";
            },
            editCryptoAccount(data, index) {
                this.bool_CryptoAccountCV = false;
                this.obj_CryptoAccount = Object.assign({}, data);
                this.bool_isMemberCryptoAccountDetailV = true;
                this.editCryptoAccountIndex = index;
                this.str_invalidNumericMsg = "";
                this.obj_CryptoAccount.IUT = false;
                if (this.obj_CryptoAccount.status != "new") {
                    this.obj_CryptoAccount.status = "edit";
                }
            },
            removeCryptoAccount(index) {
                this.dummyInt = 0;

                //remove directly inside the list
                this.$delete(this.obj_member.CryptoAccountList, index);

                this.dummyInt++;
            },
            saveCryptoAccount() {
                this.bool_CryptoAccountCV = true;
                var iurlTab = this.getIURLTabIndex();
                if (iurlTab != 1) { // external img url
                    if (this.obj_CryptoAccount.QRCURL != null && this.obj_CryptoAccount.QRCURL != "") {
                        //if img url is not empty
                        this.obj_CryptoAccount.IUT = true;
                        this.obj_CryptoAccount.QRCImage = "";
                    }
                }

                this.$v.obj_CryptoAccount.$touch();

                let isValid = true;

                if (!this.$v.obj_CryptoAccount.$error && isValid) {
                    var exist = false;
                    if (!this.obj_member.CryptoAccountList) {
                        this.obj_member.CryptoAccountList = [];
                    }
                    for (var i = this.obj_member.CryptoAccountList.length - 1; i >= 0; i--) {
                        if ((this.obj_member.CryptoAccountList[i].CAI == this.obj_CryptoAccount.CAI && this.obj_member.CryptoAccountList[i].CA == this.obj_CryptoAccount.CA && this.obj_member.CryptoAccountList[i].CAD == this.obj_CryptoAccount.CAD)
                            && this.editCryptoAccountIndex != i) {
                            exist = true;
                            break;
                        }
                        // remove duplicate default crypto account
                        if (this.obj_CryptoAccount.IDA) {
                            this.obj_member.CryptoAccountList[i].IDA = false;
                        }
                    }
                    if (!exist && this.editCryptoAccountIndex != -1) {
                        this.obj_member.HEC = true;

                        this.obj_member.CryptoAccountList[this.editCryptoAccountIndex] = this.obj_CryptoAccount;
                        this.bool_isMemberCryptoAccountDetailV = false;
                        this.bool_CryptoAccountCV = false;
                        this.editCryptoAccountIndex = -1;
                        this.obj_CryptoAccount = {};
                    }
                    else if (exist) {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1002'), this.getLanguage["MEM"]["BA"]), 1000);
                    }
                    else {
                        //this.obj_member.HEB = true;
                        this.obj_member.CryptoAccountList.push(this.obj_CryptoAccount);
                        this.bool_isMemberCryptoAccountDetailV = false;
                        this.bool_CryptoAccountCV = false;
                        this.editCryptoAccountIndex = -1;
                        this.obj_CryptoAccount = {};
                    }
                } else {
                    //find out the unfilled and required inputm then focus it.
                    const validation = this.$v["obj_CryptoAccount"];
                    if (!validation) {
                        return;
                    }

                    const input = this.findRequiredInput(validation, this.$refs);
                    if (!input || typeof input.focus !== "function") {
                        return;
                    }

                    input.focus();
                }
                this.selectedQRCode = null;
            },
            closeAddCryptoAccount() {
                this.obj_CryptoAccount = {
                    CAI: null,
                    CN: null,
                    CA: null,
                    CAD: null,
                    QRCImage: "",
                    QRCURL: "",
                    IUT: false,
                    status: "new",
                }
                this.bool_isMemberCryptoAccountDetailV = !this.bool_isMemberCryptoAccountDetailV;
                this.editCryptoAccountIndex = -1;
                this.selectedQRCode = null;
            },
            selectEditCryptoNetwork({ value, instanceId }) {
                this.obj_CryptoAccount.CN = '';
                if (this.obj_CryptoAccount.CAI) {
                    for (var i = 0; i < this.ddEditCryptoNetworkList.length; i++) {
                        if (this.ddEditCryptoNetworkList[i].id == this.obj_CryptoAccount.CAI) {
                            this.obj_CryptoAccount.CN = this.ddEditCryptoNetworkList[i].label;
                            break;
                        }
                    }
                }
            },
            ValidationCryptoAccountErrMsg(value, lang) {

                if (this.bool_CryptoAccountCV) {
                    if (!this.$v.obj_CryptoAccount[value].required) {
                        return String.format(this.utilGetErrorLanguage('1001'), this.utilGetErrorLanguage('MEM.' + lang));
                    }
                }
            },
            DefaultCryptoChange(accountId) {
                if (this.obj_member && this.obj_member.CryptoAccountList.length > 0) {
                    for (var i = 0; i < this.obj_member.CryptoAccountList.length; i++) {
                        if (this.obj_member.CryptoAccountList[i].I == accountId && this.obj_member.CryptoAccountList[i].IDA) {
                            this.obj_member.CryptoAccountList[i].IDA = false;
                            this.obj_CryptoAccount.IDA = false;
                        } else if (this.obj_member.CryptoAccountList[i].I == accountId && !this.obj_member.CryptoAccountList[i].IDA) {
                            this.obj_member.CryptoAccountList[i].IDA = true;
                            this.obj_CryptoAccount.IDA = true;
                        } else {
                            this.obj_member.CryptoAccountList[i].IDA = false;
                            this.obj_CryptoAccount.IDA = false;
                        }
                    }
                    this.obj_member.HEC = true;
                }
            },
            onCryptoQRCSelected(event) {
                var image = this.validateFile(event, 0.1, [".jpg", ".jpeg", ".png"]);
                if (image) {
                    this.obj_CryptoAccount.QRCImage = image;
                    this.selectedQRCode = image;
                }
            },
            getQRCUrl(newImage, existingImage) {
                if (newImage) {
                    return URL.createObjectURL(newImage);
                } else {
                    return this.getImgUrl(existingImage);
                }
            },
            getIURLTabIndex() {
                var result = 0;
                try {
                    var x = document.querySelector('#imageURLTab .nav.nav-tabs li a.active').innerText;
                    if (x == "Upload Image") {
                        result = 1;
                        return result;
                    }
                    else if (x === undefined) {
                        return result;
                    }
                    else {
                        result = 2;
                        return result;
                    }
                }
                catch (ex) {
                    console.log(ex);
                }
                return result;
            },
            setPreview(newImg, oldImg) {
                this.$parent.previewUrl = newImg ? URL.createObjectURL(newImg) : oldImg;
                this.$parent.bool_fullPreview = true;
            },


            //blacklist
            blacklistMember(d) {
                this.bool_blacklistCV = false;
                //this.dd_rejectreason = constRejectReasonBL;
                this.obj_blacklist = {
                    RM: null,
                    _d: d
                };
                this.obj_Reject = {
                    "reason": null,
                    "reason2": ""
                },

                    this.bool_isMemberBlacklistDetailV = true;
            },
            unBlacklistMember(d) {
                this.$fire({
                    title: this.getLanguage["MEM"]["CUBLK"],
                    width: '30em',
                    showCancelButton: true,
                    confirmButtonText: this.getLanguage["GL"]["YES"],
                    cancelButtonText: this.getLanguage["CNO"]["NO"],
                    reverseButtons: true,
                    customClass: {
                        title: 'afb-alert-title',
                        content: 'afb-alert-content',
                        actions: 'afb-alert-action'
                    }
                }).then((result) => {
                    if (result.value == true) {
                        this.$parent.bool_fullLoading = true;
                        var that = this;
                        var dt = {
                            i: d.I,
                            uts: d.UTS,
                            agi: d.AGI,
                            CI: d.CI,
                            U: d.U
                        };

                        this.postDataApi(`/api/m/ubm`, dt,
                            function (d, s) {
                                that.$parent.bool_fullLoading = false;

                                if (s) {
                                    that.$parent.editMemberInfo = null;
                                    that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
                                }
                            });
                    }
                });
            },
            saveBlacklist() {
                this.bool_blacklistCV = true;

                var rejectreason = this.obj_Reject.reason == 999 ? this.obj_Reject.reason2 : this.obj_Reject.reason;

                if (rejectreason != "" && rejectreason != null) {
                    this.$parent.bool_fullLoading = true;
                    this.$parent.bool_fullScreen = false;
                    var that = this;
                    var dt = [{
                        I: this.obj_blacklist._d.I,
                        UTS: this.obj_blacklist._d.UTS,
                        BR: rejectreason,
                        AGI: this.obj_blacklist._d.AGI,
                        ICI: 0,
                        CI: this.obj_blacklist._d.CI,
                        U: this.obj_blacklist._d.U
                    }];

                    //this.postDataApi(`/api/m/bm`, dt,
                    //    function (d, s)
                    //    {
                    //        that.$parent.bool_fullLoading = false;

                    //        if (s)
                    //        {
                    //            that.bool_isMemberBlacklistDetailV = false;
                    //            that.getMemberList();
                    //        }
                    //    });
                    this.postDataApi(`/api/m/bm`, dt,
                        function (d, s) {
                            that.$parent.bool_fullLoading = false;
                            that.$parent.bool_fullScreen = false;
                            if (s) {
                                if (d.ERR && d.ERR.length > 0 && d.ERR[0].ERRC == 99) {
                                    that.$fire({
                                        title: that.getLanguage["MEM"]["CA"],
                                        html: that.getLanguage["MEM"]["CICI"],
                                        width: '30em',
                                        showCancelButton: true,
                                        confirmButtonText: 'Ok',
                                        cancelButtonText: 'Cancel',
                                        reverseButtons: true,
                                        customClass: {
                                            title: 'afb-alert-title',
                                            content: 'afb-alert-content',
                                            actions: 'afb-alert-action'
                                        }
                                    }).then((result) => {
                                        if (result.value == true) {
                                            that.bool_fullLoading = true;
                                            dt[0]['ICI'] = 1;
                                            that.postDataApi(`/api/m/bm`, dt,
                                                function (d, s) {
                                                    that.$parent.bool_fullLoading = false;
                                                    if (s) {
                                                        that.bool_isMemberBlacklistDetailV = false;

                                                        that.$parent.editMemberBlock = null;
                                                        if (that.$route.path == '/M/ML') {
                                                            that.$parent.getMemberList();
                                                        } else if (that.$route.path == '/M/ML/CheckingMember') {
                                                            that.$parent.getData();
                                                        }
                                                    }
                                                });
                                        }
                                    });
                                }
                                else {
                                    that.bool_isMemberBlacklistDetailV = false;

                                    that.$parent.editMemberBlock = null;
                                    if (that.$route.path == '/M/ML') {
                                        that.$parent.getMemberList();
                                    } else if (that.$route.path == '/M/ML/CheckingMember') {
                                        that.$parent.getData();
                                    }
                                }
                            }
                        });
                }
            },
            getRejectReason() {
                this.dd_rejectreason = [{ id: "1", label: this.getLanguage['MEM']['SIMA'] }, { id: "2", label: this.getLanguage['MEM']['HCD'] },
                { id: "3", label: this.getLanguage['MEM']['SAA'] }, { id: "4", label: this.getLanguage['MEM']['IM'] }, { id: "999", label: this.getLanguage['BETRPT']['OTR'] }];
            },
            ValidationBlackListErrMsg(value) {
                if (this.bool_blacklistCV) {
                    var validateObj = this.$v.obj_Reject[value];
                    if (validateObj.required != undefined && !validateObj.required) {
                        return String.format(this.getLanguage["ERR"]["1001"], this.getLanguage["MEM"]["RR"]);
                    }
                }
            },
            close3() {
                this.bool_isMemberBlacklistDetailV = !this.bool_isMemberBlacklistDetailV;
                this.bool_blacklistCV = false;
                this.$parent.editMemberBlock = null;
            },

            //freeze
            freezeMember(d) {
                this.bool_freezeCV = false;
                //this.dd_rejectreasonF = constRejectReasonF;
                this.obj_freeze = {
                    RM: null,
                    _d: d
                };
                this.obj_RejectF = {
                    "reason": null,
                    "reason2": ""
                },

                    this.bool_isMemberFreezeDetailV = true;
            },
            unFreezeMember(d) {
                this.$fire({
                    title: this.getLanguage["MEM"]["CUF"],
                    width: '30em',
                    showCancelButton: true,
                    confirmButtonText: this.getLanguage["GL"]["YES"],
                    cancelButtonText: this.getLanguage["CNO"]["NO"],
                    reverseButtons: true,
                    customClass: {
                        title: 'afb-alert-title',
                        content: 'afb-alert-content',
                        actions: 'afb-alert-action'
                    }
                }).then((result) => {
                    if (result.value == true) {
                        this.$parent.bool_fullLoading = true;
                        var that = this;
                        var dt = {
                            i: d.I,
                            uts: d.UTS,
                            agi: d.AGI
                        };

                        this.postDataApi(`/api/m/ufm`, dt,
                            function (d, s) {
                                that.$parent.bool_fullLoading = false;

                                if (s) {
                                    that.$parent.editMemberFreeze = null;
                                    if (that.$route.path == '/M/ML') {
                                        that.$parent.getMemberList();
                                    } else if (that.$route.path == '/M/ML/CheckingMember') {
                                        that.$parent.getData();
                                    }

                                    that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
                                }
                            });
                    }
                });
            },
            saveFreeze() {
                this.bool_freezeCV = true;

                var rejectreason = this.obj_RejectF.reason == 999 ? this.obj_RejectF.reason2 : this.obj_RejectF.reason;

                if (rejectreason != "" && rejectreason != null) {
                    this.$parent.bool_fullLoading = true;
                    this.$parent.bool_fullScreen = false;
                    var that = this;
                    var dt = [{
                        I: this.obj_freeze._d.I,
                        UTS: this.obj_freeze._d.UTS,
                        FR: rejectreason,
                        AGI: this.obj_freeze._d.AGI,
                        ICI: 0
                    }];

                    this.postDataApi(`/api/m/fm`, dt,
                        function (d, s) {
                            that.$parent.bool_fullLoading = false;
                            that.$parent.bool_fullScreen = false;
                            if (s) {
                                if (d.ERR && d.ERR.length > 0 && d.ERR[0].ERRC == 99) {
                                    that.$fire({
                                        title: that.getLanguage["MEM"]["CA"],
                                        html: that.getLanguage["MEM"]["CICI"],
                                        width: '30em',
                                        showCancelButton: true,
                                        confirmButtonText: 'Ok',
                                        cancelButtonText: 'Cancel',
                                        reverseButtons: true,
                                        customClass: {
                                            title: 'afb-alert-title',
                                            content: 'afb-alert-content',
                                            actions: 'afb-alert-action'
                                        }
                                    }).then((result) => {
                                        if (result.value == true) {
                                            that.$parent.bool_fullLoading = true;

                                            dt[0]['ICI'] = 1;
                                            that.postDataApi(`/api/m/fm`, dt,
                                                function (d, s) {
                                                    that.$parent.bool_fullLoading = false;
                                                    if (s) {
                                                        that.bool_isMemberFreezeDetailV = false;

                                                        that.$parent.editMemberFreeze = null;
                                                        if (that.$route.path == '/M/ML') {
                                                            that.$parent.getMemberList();
                                                        } else if (that.$route.path == '/M/ML/CheckingMember') {
                                                            that.$parent.getData();
                                                        }
                                                    }
                                                });
                                        }
                                    });
                                }
                                else {
                                    that.bool_isMemberFreezeDetailV = false;

                                    that.$parent.editMemberFreeze = null;
                                    if (that.$route.path == '/M/ML') {
                                        that.$parent.getMemberList();
                                    } else if (that.$route.path == '/M/ML/CheckingMember') {
                                        that.$parent.getData();
                                    }
                                }
                            }
                        });
                }
            },
            getRejectReasonF() {
                this.dd_rejectreasonF = [{ id: "1", label: this.getLanguage['MEM']['SIMA'] }, { id: "2", label: this.getLanguage['MEM']['HCD'] },
                { id: "3", label: this.getLanguage['MEM']['SAA'] }, { id: "4", label: this.getLanguage['MEM']['IM'] }, { id: "999", label: this.getLanguage['BETRPT']['OTR'] }];
            },
            ValidationFreezeErrMsg(value) {
                if (this.bool_freezeCV) {
                    var validateObj = this.$v.obj_RejectF[value];
                    if (validateObj.required != undefined && !validateObj.required) {
                        return String.format(this.getLanguage["ERR"]["1001"], this.getLanguage["MEM"]["FRR"]);
                    }
                }
            },
            close4() {
                this.bool_isMemberFreezeDetailV = !this.bool_isMemberFreezeDetailV;
                this.bool_FreezeCV = false;
                this.$parent.editMemberFreeze = null;
            },

            //game setting
            editMemberGameSetting(d) {
                this.bool_isMemberGameSetting = true;
                if (d == 0) {

                }
                else {
                    var that = this;
                    that.$parent.bool_fullLoading = true;
                    that.bool_isMemberGameSetting = true;

                    if (d.AGI != null && d.IOL) {
                        d.AGI = d.SAGI;
                    }
                    this.getDataApi(`/api/m/gmgs/${d.AGI}/${d.I}/${d.CI}/${d.MTI}/${d.ICT}`,
                        function (d, s) {
                            that.$parent.bool_fullLoading = false;
                            that.arr_displayGCI = [];
                            that.arr_displayGPI = [];
                            //that.arr_currencies = d.Item2;

                            if (s) {
                                that.noData = true;
                                if (s && d && d.length) {
                                    that.noData = false;
                                    if (d.length > 0) {
                                        var prevCategoryId = null;
                                        var prevProviderId = null;
                                        var prevCurrencyId = null;

                                        that.dd_gp_currency = _.groupBy(d, 'PN');
                                        for (var key in that.dd_gp_currency) {
                                            if (key != 'null') {
                                                if (that.arr_currencies.length > 0) {
                                                    var filterData = [];
                                                    for (var x = 0; x < that.dd_gp_currency[key].length; x++) {
                                                        if (that.arr_currencies.includes(that.dd_gp_currency[key][x]['CI'])) {
                                                            filterData.push(that.dd_gp_currency[key][x]);
                                                        }
                                                    }
                                                    that.dd_gp_currency[key] = _.compact(_.uniq(_.map(filterData, 'ISOC')));
                                                } else {
                                                    that.dd_gp_currency[key] = _.compact(_.uniq(_.map(that.dd_gp_currency[key], 'ISOC')));
                                                }
                                            }
                                        }

                                        for (var i = 0; i < d.length; i++) {
                                            if (prevCategoryId == d[i].GCI) {
                                                d[i].CN = null;
                                            }

                                            prevCategoryId = d[i].GCI;

                                            if (prevProviderId == d[i].GPI && prevCurrencyId == d[i].CI) {
                                                d[i].PN = null;
                                            }

                                            prevProviderId = d[i].GPI;

                                            if (prevCurrencyId == d[i].CI) {
                                                d[i].DFFC = false;
                                            }
                                            else {
                                                d[i].DFFC = true;
                                            }

                                            prevCurrencyId = d[i].CI;

                                            if (d[i].SVT == 1 && !d[i].SV) {
                                                d[i].SV = null;
                                            }

                                            if (d[i].SN === 'AfbSports') {
                                                let sportData = null;
                                                if (d[i].SV && d[i].SV.trim() !== '') {
                                                    const dbSports = d[i].SV.split(',').map(Number);
                                                    for (let j = 0; j < that.afbSports[0].children.length; j++) {
                                                        let child = that.afbSports[0].children[j];
                                                        //if doesnt include any one of ids, it means not all sports are selected to dbSports.
                                                        if (!dbSports.includes(child.id)) {
                                                            sportData = {
                                                                idx: i,
                                                                selections: dbSports
                                                            };
                                                            break;
                                                        }

                                                        //if dbSports include all, then change its value to 0.
                                                        if (j === that.afbSports[0].children.length - 1) {
                                                            sportData = {
                                                                idx: i,
                                                                selections: [0]
                                                            };
                                                        }
                                                    }
                                                    //no value, shows all.
                                                } else {
                                                    sportData = {
                                                        idx: i,
                                                        selections: [0]
                                                    }
                                                }

                                                that.selectedSports[d[i].GPI] = sportData;
                                            }
                                        }
                                    }
                                }
                                that.arr_memberGameSetting = d;

                                setTimeout(() => {
                                    $("#MGS .row .section-title2").each(function (index) {
                                        $(this).find('span').html(index + 1);
                                    });
                                }, 500)
                            }
                        });
                }
            },
            RenderSettingName(settingName, providerId) {
                if (providerId == 4 && ((settingName == "Min" && "MINS" in this.getLanguage['GS'])
                    || (settingName == "Max" && "MAXS" in this.getLanguage['GS']))) {
                    return this.getLanguage['GS'][settingName.toUpperCase() + "S"];
                }
                else if (settingName && settingName.toUpperCase() in this.getLanguage['GS']) {
                    return this.getLanguage['GS'][settingName.toUpperCase()];
                }
                else {
                    return settingName;
                }
            },
            closeEditMemberGameSetting() {
                this.bool_isMemberGameSetting = !this.bool_isMemberGameSetting;
                this.$parent.editMemberGame = null;
            },
            renderCategory(id) {
                return this.getLanguage["GC"][id];
            },
            DisplayGCI(categoryId) {
                const idx = this.arr_displayGCI.indexOf(categoryId);
                if (idx !== -1) {
                    this.arr_displayGCI.splice(idx, 1);
                } else {
                    this.arr_displayGCI.push(categoryId);
                }
            },
            DisplayGPI(gpi) {
                if (this.arr_displayGPI.includes(gpi)) {
                    this.arr_displayGPI.splice(this.arr_displayGPI.indexOf(gpi), 1);
                } else {
                    this.arr_displayGPI.push(gpi);
                }
            },
            saveMemberGameSetting() {
                //const sportList = this.afbSports[0].children.map(child => child.id).join(",");
                //const afbSportsSetting = this.arr_memberGameSetting.find(o => o.SN === 'AfbSports');
                //if (afbSportsSetting) {
                //    afbSportsSetting.SV = sportList
                //}

                this.$v.arr_memberGameSetting.$touch();
                if (!this.$v.arr_memberGameSetting.$error) {
                    //handle sportList for AFB1188
                    //for (const [key, value] of Object.entries(this.selectedSports)) {
                    //    let sportsText = null;
                    //    if (!value.selections || value.selections.length === 0) {
                    //        //should suspend and return an error message here
                    //    } else if (value.selections.includes(0)) {
                    //        this.afbSports[0].children.forEach((o, idx) => {
                    //            sportsText += o.id;
                    //            if (idx !== this.afbSports[0].children.length - 1) {
                    //                sportsText += ",";
                    //            }
                    //        });
                    //    } else {
                    //        sportsText = value.selections.join(',');
                    //    }
                    //    this.settingList[value.idx].SV = sportsText
                    //}

                    var that = this;
                    this.$parent.bool_fullLoading = true;
                    this.$parent.bool_fullScreen = true;
                    this.postDataApi(`/api/m/smgs`, this.arr_memberGameSetting,
                        function (d, s) {
                            that.$parent.bool_fullLoading = false;
                            that.$parent.bool_fullScreen = false;
                            if (s) {
                                that.bool_isMemberGameSetting = false;

                                that.$parent.editMemberGame = null;
                                if (that.$route.path == '/M/ML') {
                                    that.$parent.getMemberList();
                                } else if (that.$route.path == '/M/ML/CheckingMember') {
                                    that.$parent.getData();
                                }
                            }
                        });
                }
            },
            ValidationErrMsg(gpi,index) {
                var errObj = this.$v.arr_memberGameSetting.$each.$iter[index].SV;               
                if (!errObj.decimal) {
                    if (gpi === 4 || gpi === 139) {
                        return String.format(this.getLanguage['ERR']['1009'], this.getLanguage['GS']['VAL']);
                    }
                    else {
                        return String.format(this.getLanguage['ERR']['1007'], this.getLanguage['GS']['VAL']);
                    }
                }
                return null;
            },




        },
        validations: {
            obj_bank: {
                BA: { required },
                //BAN: { required, alphaNum },
                BI: { required },
                BAN: { required },
            },
            obj_CryptoAccount: {
                CAI: { required },
                CA: { required },
                CAD: { required },
            },
            obj_member: {
                AGI: { required },
                U: { required, alphaNum },
                UP: {
                    required: requiredIf(function (vm) {
                        return vm.I == 0;
                    }),
                },
                CUP: {
                    required: requiredIf(function (vm) {
                        return vm.I == 0;
                    }),
                    sameAsPassword: sameAs(function (vm) { return vm.I == 0 || (vm.UP != '' && vm.UP != null) ? vm.UP : vm.CUP; })
                },
                NUP: {
                    required: requiredIf(function (vm) {
                        return vm.I == 0 && this.isOUTMOB;
                    }),
                },
                // MRI: { required },
                CI: { required },
                // DN: { required },
                // PN: { required },
                // E: { email },
            },
            arr_memberGameSetting: {
                $each: {
                    SV: {
                        decimal: (function (value, obj) {
                            if (value && (obj.SVT == 0 || obj.SVT == 2)) {
                                return this.regexDecimal.test(value);
                            }

                            return true;
                        })
                    }
                }
            },
            obj_ad: {
                TT: { required },
                R: { required },
                TA: { required, decimal, minValueValue: minValue(0) }
            },
            obj_Reject: {
                reason2: {
                    required: requiredIf(function (vm) {
                        return !vm.reason || vm.reason == 999;
                    }),
                }
            },
            obj_RejectF: {
                reason2: {
                    required: requiredIf(function (vm) {
                        return !vm.reason || vm.reason == 999;
                    }),
                }
            },
        },
        computed: {
            ...mapGetters('Language', ['getLanguage', 'getLangCode']),
            ...mapGetters('UserInfo', ['getUserInfo', 'checkModuleAccess', 'getUserMemberSC']),
            ...mapGetters('CurrencyInfo', ['getThousandCurrency']),
            selectedAgent: {
                get() {

                    if (this.ddAgentList && this.ddAgentList.length === 1) {
                        let currentItem = this.ddAgentList[0];

                        while (currentItem.children && Array.isArray(currentItem.children)) {
                            if (currentItem.children.length === 1) {
                                currentItem = currentItem.children[0];
                            } else if (currentItem.children.length > 1) {
                                return this.searchAgent;
                            } else {
                                return currentItem.id;
                            }
                        }
                        return currentItem.id;
                    }
                    return this.searchAgent;
                },
                set(value) {
                    this.searchAgent = value;
                    this.getCurrencyList();
                }
            }
        },
        watch: {
            bool_isMemberBlacklistDetailV(newValue) {
                if (!newValue) {
                    this.cleanSuccessErrorMessage();
                }
                if (!this.bool_isMemberBlacklistDetailV && this.bool_blacklistCV) {
                    this.showSuccessMessage(this.utilGetErrorLanguage("ERR.SS"), this.utilGetErrorLanguage("GL.AS"));
                }
            },
            bool_isMemberFreezeDetailV(newValue) {
                if (!newValue) {
                    this.cleanSuccessErrorMessage();
                }
                if (!this.bool_isMemberFreezeDetailV && this.bool_FreezeCV) {
                    this.showSuccessMessage(this.utilGetErrorLanguage("ERR.SS"), this.utilGetErrorLanguage("GL.AS"));
                }
            },
            bool_isAMV() {
                if (!this.bool_isAMV && this.bool_memberCV) {
                    this.showSuccessMessage(this.utilGetErrorLanguage("ERR.SS"), this.utilGetErrorLanguage("GL.AS"));
                }
            },
            getLanguage() {
                this.getCurrencyList();
                //this.getMemberList();
                this.getRejectReason();
                this.getRejectReasonF();
            },
            editMemberInfo() {
                if (this.editMemberInfo == null) {

                } else if (this.editMemberInfo == 0) {
                    this.editMember(0)
                } else {
                    this.editMember(this.editMemberInfo)
                }
            },
            editMemberBlock() {
                if (this.editMemberBlock == null) {

                } else {
                    this.blacklistMember(this.editMemberBlock)
                }
            },
            editMemberFreeze() {
                if (this.editMemberFreeze == null) {

                } else {
                    this.freezeMember(this.editMemberFreeze)
                }
            },
            editMemberGame() {
                if (this.editMemberGame == null) {

                } else {
                    this.editMemberGameSetting(this.editMemberGame)
                }
            },
        },
        created() {
            this.$parent.showSubMenu = 'M';
            this.$parent.showActiveMenu = 'M.ML';
            if (this.getUserInfo.AT == 4) {
                this.getAgentGroup();
                this.loadDefaultSubBrand(0, true);
            }
            this.ML_A = this.checkModuleAccess('ML', 'M', constAccessType.add);
            this.ML_E = this.checkModuleAccess('ML', 'M', constAccessType.edit);
            this.ML_D = this.checkModuleAccess('ML', 'M', constAccessType.delete);
            this.MBA_A = this.checkModuleAccess('MBA', 'M', constAccessType.add);
            this.MAR_E = this.checkModuleAccess('MAR', 'M', constAccessType.edit);

            this.HideContactInfo = this.getUserInfo.IHMI_C;
            this.EditContactInfo = !this.getUserInfo.IHMI_C && this.checkModuleAccess('VEC', 'M', constAccessType.edit);
            this.HideBankInfo = this.getUserInfo.IHMI;
            this.EditBankInfo = !this.getUserInfo.IHMI && this.checkModuleAccess('VEB', 'M', constAccessType.edit);
            this.HideCryptoAccountInfo = this.getUserInfo.IHMI;
            this.EditCryptoAccountInfo = !this.getUserInfo.IHMI && this.checkModuleAccess('VEB', 'M', constAccessType.edit);

            this.onOffOptionList = [{ id: '', label: '' }, { id: '0', label: this.getLanguage['GS']['OFF'] }, { id: '1', label: this.getLanguage['GS']['ON'] }];
            this.dd_tranType = constTranType;
            this.bool_isMobileDevice = this.getUserInfo.IMD && this.getUserInfo.AT == 4;
            this.isSENS = this.getUserInfo.ISENS;
            this.isOUTMOB = (localStorage.getItem('isOutletMobile') == 'True') ? true : false;
            this.curAGI = this.getUserInfo.AGI;
            this.getAgentGroup();
            this.getCurrencyList();
            this.getRejectReason();
            this.getRejectReasonF();
        }
    }
</script>

<style>
    .breadcrumb-item + .font-xl.breadcrumb-item::before {
        color: rgb(140, 195, 38);
        content: '>>';
        padding: 0px 10px;
    }

    .c-sidebar-nav-lin {
        white-space: normal;
    }
</style>



// WEBPACK FOOTER //
// src/components/SideMenu/Member/MemberCombineModal.vue